import React from "react";

import { IconName } from "../types";

export const Icon = (props: { name: IconName | string; className?: string }) => {
  return (
    <div
      className={`pyht-icon icon-${props.name.toLowerCase().replaceAll(" ","")} ${
        props.className ? props.className : ""
      }`}
    >
      {props.name === IconName.ARROW ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29.247"
          height="14.167"
          viewBox="0 0 29.247 14.167"
        >
          <g id="Group_2844" data-name="Group 2844" transform="translate(163)">
            <path
              id="Path_2948"
              data-name="Path 2948"
              d="M28.912,138.275h0l-5.97-5.941a1.142,1.142,0,0,0-1.612,1.62l4.008,3.989H1.142a1.142,1.142,0,1,0,0,2.285H25.337l-4.008,3.989a1.142,1.142,0,0,0,1.612,1.62l5.97-5.941h0A1.143,1.143,0,0,0,28.912,138.275Z"
              transform="translate(-163 -132)"
              fill="currentColor"
            />
          </g>
        </svg>
      ) : props.name === IconName.ARROW_THIN ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32.031"
          height="25.344"
          viewBox="0 0 32.031 25.344"
        >
          <g
            id="down-arrow_1_"
            data-name="down-arrow (1)"
            transform="translate(0 78.786) rotate(-90)"
          >
            <path
              id="Path_28"
              data-name="Path 28"
              d="M77.673,18.879,66.8,29.752V.667a.667.667,0,1,0-1.335,0V29.752L54.595,18.879a.667.667,0,0,0-.944.944L65.663,31.834a.667.667,0,0,0,.944,0h0L78.619,19.823a.667.667,0,0,0-.944-.944Z"
              transform="translate(-0.02)"
              fill="#b62427"
            />
            <path
              id="Path_29"
              data-name="Path 29"
              d="M66.114,312.145a.667.667,0,0,1-.472-.195L53.63,299.939a.667.667,0,0,1,.944-.944l11.54,11.539,11.539-11.539a.667.667,0,0,1,.944.944L66.585,311.95A.667.667,0,0,1,66.114,312.145Z"
              transform="translate(0 -280.114)"
              fill="#b62427"
            />
            <path
              id="Path_30"
              data-name="Path 30"
              d="M245.989,32.031a.667.667,0,0,1-.667-.667V.667a.667.667,0,1,1,1.335,0v30.7A.667.667,0,0,1,245.989,32.031Z"
              transform="translate(-179.875)"
              fill="#b62427"
            />
          </g>
        </svg>
      ) : props.name === IconName.ARROW_THIN_BLACK ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32.031"
          height="25.344"
          viewBox="0 0 32.031 25.344"
        >
          <g
            id="down-arrow_1_"
            data-name="down-arrow (1)"
            transform="translate(0 78.786) rotate(-90)"
          >
            <path
              id="Path_28"
              data-name="Path 28"
              d="M77.673,18.879,66.8,29.752V.667a.667.667,0,1,0-1.335,0V29.752L54.595,18.879a.667.667,0,0,0-.944.944L65.663,31.834a.667.667,0,0,0,.944,0h0L78.619,19.823a.667.667,0,0,0-.944-.944Z"
              transform="translate(-0.02)"
              fill="#000000"
            />
            <path
              id="Path_29"
              data-name="Path 29"
              d="M66.114,312.145a.667.667,0,0,1-.472-.195L53.63,299.939a.667.667,0,0,1,.944-.944l11.54,11.539,11.539-11.539a.667.667,0,0,1,.944.944L66.585,311.95A.667.667,0,0,1,66.114,312.145Z"
              transform="translate(0 -280.114)"
              fill="#000000"
            />
            <path
              id="Path_30"
              data-name="Path 30"
              d="M245.989,32.031a.667.667,0,0,1-.667-.667V.667a.667.667,0,1,1,1.335,0v30.7A.667.667,0,0,1,245.989,32.031Z"
              transform="translate(-179.875)"
              fill="#000000"
            />
          </g>
        </svg>
      ) : props.name === IconName.BATH ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="26.213"
          height="8.412"
          viewBox="0 0 26.213 8.412"
        >
          <path
            id="Path_771"
            data-name="Path 771"
            d="M0,0,5.845,8.412H24.814L26.213,0Z"
            fill="#47494f"
          />
        </svg>
      ) : props.name === IconName.BED ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="22.082" height="17.765" viewBox="0 0 22.082 17.765">
          <defs>
            <clipPath id="clip-path">
              <path id="Path_768" data-name="Path 768" d="M0,7.865H22.082V-9.9H0Z" transform="translate(0 9.9)" fill="none"></path>
            </clipPath>
          </defs>
          <g id="Group_418" data-name="Group 418" transform="translate(0 9.9)">
            <g id="Group_397" data-name="Group 397" transform="translate(0 -9.9)" clipPath="url(#clip-path)">
              <g id="Group_394" data-name="Group 394" transform="translate(0 -0.001)">
                <path id="Path_765" data-name="Path 765" d="M8.5,3.454H-8.847V-3.422a.926.926,0,0,0-.926-.926.926.926,0,0,0-.926.926V12.461a.926.926,0,0,0,.926.926.926.926,0,0,0,.926-.926V9.44H9.53v3.052a.926.926,0,0,0,1.852,0V9.44h0v-3.1A2.887,2.887,0,0,0,8.5,3.454" transform="translate(10.699 4.348)" fill="#47494f"></path>
              </g>
              <g id="Group_395" data-name="Group 395" transform="translate(2.823 2.6)">
                <path id="Path_766" data-name="Path 766" d="M.962,1.924A2.173,2.173,0,0,0,3.135-.249,2.173,2.173,0,0,0,.962-2.422,2.173,2.173,0,0,0-1.211-.249,2.173,2.173,0,0,0,.962,1.924" transform="translate(1.211 2.422)" fill="#47494f"></path>
              </g>
              <g id="Group_396" data-name="Group 396" transform="translate(8.056 2.585)">
                <path id="Path_767" data-name="Path 767" d="M5.284,1.614A3.645,3.645,0,0,0,1.639-2.031h-8.29V2.346H5.284Z" transform="translate(6.651 2.031)" fill="#47494f"></path>
              </g>
            </g>
          </g>
        </svg>
      ) : props.name === IconName.BLUEPRINT ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30.061"
          height="30.061"
          viewBox="0 0 30.061 30.061"
        >
          <g id="blueprint" transform="translate(0)">
            <g
              id="Group_551"
              data-name="Group 551"
              transform="translate(4.462)"
            >
              <g id="Group_550" data-name="Group 550">
                <path
                  id="Path_814"
                  data-name="Path 814"
                  d="M99.837,0H77.761A1.763,1.763,0,0,0,76,1.761V7.926a.587.587,0,0,0,1.174,0V1.761a.588.588,0,0,1,.587-.587h3.581V3.523a.587.587,0,0,0,1.174,0V1.174h7.867V7.926a.587.587,0,0,0,.587.587h3.2a.587.587,0,0,0,.587-.587V6.243a.587.587,0,0,0-1.174,0v1.1H91.558V1.174h8.279a.588.588,0,0,1,.587.587v17.2H91.558V15.617h3.875a.587.587,0,1,0,0-1.174H90.971a.587.587,0,0,0-.587.587v4.521a.587.587,0,0,0,.587.587h9.453v3.7a.588.588,0,0,1-.587.587H92.977a.587.587,0,1,0,0,1.174h6.861a1.763,1.763,0,0,0,1.761-1.761V1.761A1.763,1.763,0,0,0,99.837,0Z"
                  transform="translate(-76)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_553"
              data-name="Group 553"
              transform="translate(4.462 12.942)"
            >
              <g id="Group_552" data-name="Group 552">
                <path
                  id="Path_815"
                  data-name="Path 815"
                  d="M88.432,231.911H87.206v-1.522a.587.587,0,0,0-.587-.587h-2.37a.587.587,0,0,0,0,1.174h1.783v.935h-8.27a.588.588,0,0,1-.587-.587v-3.7h1.233a.587.587,0,1,0,0-1.174H77.174V223.1h8.807v1.169a.587.587,0,0,0,1.174,0v-1.757a.587.587,0,0,0-.587-.587H77.174v-.914a.587.587,0,1,0-1.174,0v10.308a1.763,1.763,0,0,0,1.761,1.761H88.432a.587.587,0,1,0,0-1.174Z"
                  transform="translate(-76 -220.428)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_555"
              data-name="Group 555"
              transform="translate(25.462 14.443)"
            >
              <g id="Group_554" data-name="Group 554">
                <path
                  id="Path_816"
                  data-name="Path 816"
                  d="M434.672,246.172a.587.587,0,1,0,.172.415A.592.592,0,0,0,434.672,246.172Z"
                  transform="translate(-433.67 -246)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_557"
              data-name="Group 557"
              transform="translate(8.044 3.903)"
            >
              <g id="Group_556" data-name="Group 556">
                <path
                  id="Path_817"
                  data-name="Path 817"
                  d="M143.987,66.469a.587.587,0,0,0-.587.587v5.17h-5.813a.587.587,0,1,0,0,1.174h6.4a.587.587,0,0,0,.587-.587V67.056A.587.587,0,0,0,143.987,66.469Z"
                  transform="translate(-137 -66.469)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_559"
              data-name="Group 559"
              transform="translate(3.993 27.259)"
            >
              <g id="Group_558" data-name="Group 558">
                <path
                  id="Path_818"
                  data-name="Path 818"
                  d="M93.9,465.273l-.813-.814a.587.587,0,0,0-.957.642H69.943a.587.587,0,0,0-.957-.642l-.814.814a.587.587,0,0,0,0,.83l.814.814a.587.587,0,0,0,.957-.642H92.126a.587.587,0,0,0,.957.642l.814-.814A.587.587,0,0,0,93.9,465.273Z"
                  transform="translate(-68 -464.288)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g id="Group_561" data-name="Group 561" transform="translate(0 0)">
              <g id="Group_560" data-name="Group 560">
                <path
                  id="Path_819"
                  data-name="Path 819"
                  d="M1.988,24.127V1.943A.587.587,0,0,0,2.63.986L1.816.173a.587.587,0,0,0-.83,0L.172.986a.587.587,0,0,0,.642.957V24.127a.587.587,0,0,0-.642.957l.814.814a.587.587,0,0,0,.83,0l.814-.814a.587.587,0,0,0-.642-.957Z"
                  transform="translate(0 -0.001)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_563"
              data-name="Group 563"
              transform="translate(4.462 9.659)"
            >
              <g id="Group_562" data-name="Group 562">
                <path
                  id="Path_820"
                  data-name="Path 820"
                  d="M77,164.692a.587.587,0,1,0,.172.415A.592.592,0,0,0,77,164.692Z"
                  transform="translate(-76 -164.52)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_565"
              data-name="Group 565"
              transform="translate(26.385 7.134)"
            >
              <g id="Group_564" data-name="Group 564">
                <path
                  id="Path_821"
                  data-name="Path 821"
                  d="M450.563,122.06a.587.587,0,0,0-1.173.055c0,.059,0,.119,0,.178a.587.587,0,1,0,1.174,0C450.568,122.216,450.566,122.137,450.563,122.06Z"
                  transform="translate(-449.389 -121.501)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_568"
              data-name="Group 568"
              transform="translate(24.082 3.501)"
            >
              <g id="Group_567" data-name="Group 567">
                <g id="Group_566" data-name="Group 566">
                  <path
                    id="Path_822"
                    data-name="Path 822"
                    d="M411.363,59.884c-.107-.068-.217-.132-.329-.191a.587.587,0,1,0-.551,1.037c.085.045.169.094.25.146a.587.587,0,1,0,.63-.991Z"
                    transform="translate(-410.171 -59.623)"
                    fill="currentColor"
                  />
                  <path
                    id="Path_823"
                    data-name="Path 823"
                    d="M439.246,85.97c-.059-.111-.124-.222-.191-.329a.587.587,0,1,0-.991.63c.052.081.1.166.146.25a.587.587,0,1,0,1.037-.552Z"
                    transform="translate(-436.34 -83.858)"
                    fill="currentColor"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_570"
              data-name="Group 570"
              transform="translate(22.045 2.994)"
            >
              <g id="Group_569" data-name="Group 569">
                <path
                  id="Path_824"
                  data-name="Path 824"
                  d="M376.29,51.005c-.077,0-.155-.005-.233-.005a.587.587,0,0,0,0,1.174c.059,0,.119,0,.178,0h.028a.587.587,0,0,0,.027-1.174Z"
                  transform="translate(-375.47 -51)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_572"
              data-name="Group 572"
              transform="translate(14.091 17.97)"
            >
              <g id="Group_571" data-name="Group 571">
                <path
                  id="Path_825"
                  data-name="Path 825"
                  d="M240.793,306.075c-.077,0-.155,0-.233.005a.587.587,0,0,0,.027,1.174h.028c.059,0,.119,0,.178,0a.587.587,0,1,0,0-1.174Z"
                  transform="translate(-240 -306.075)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_575"
              data-name="Group 575"
              transform="translate(10.458 18.477)"
            >
              <g id="Group_574" data-name="Group 574">
                <g id="Group_573" data-name="Group 573">
                  <path
                    id="Path_826"
                    data-name="Path 826"
                    d="M205.262,315.008a.587.587,0,0,0-.794-.242c-.112.059-.222.124-.329.191a.587.587,0,1,0,.63.991c.081-.052.165-.1.25-.146A.587.587,0,0,0,205.262,315.008Z"
                    transform="translate(-202.356 -314.696)"
                    fill="currentColor"
                  />
                  <path
                    id="Path_827"
                    data-name="Path 827"
                    d="M179.193,340.535a.587.587,0,0,0-.81.181c-.068.107-.132.217-.191.329a.587.587,0,1,0,1.037.551c.045-.085.094-.169.146-.25A.587.587,0,0,0,179.193,340.535Z"
                    transform="translate(-178.122 -338.932)"
                    fill="currentColor"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_577"
              data-name="Group 577"
              transform="translate(9.952 22.11)"
            >
              <g id="Group_576" data-name="Group 576">
                <path
                  id="Path_828"
                  data-name="Path 828"
                  d="M170.119,376.575a.587.587,0,0,0-.614.559c0,.077-.005.156-.005.233a.587.587,0,1,0,1.174,0c0-.059,0-.119,0-.178A.587.587,0,0,0,170.119,376.575Z"
                  transform="translate(-169.5 -376.574)"
                  fill="currentColor"
                />
              </g>
            </g>
          </g>
        </svg>
      ) : props.name === IconName.CAR ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18.997"
          height="15.886"
          viewBox="0 0 18.997 15.886"
        >
          <path
            id="Path_776"
            data-name="Path 776"
            d="M.586,4.789H-.965V2.1c0-.75-.01-1.5,0-2.251A2.226,2.226,0,0,1,.421-2.32,1.15,1.15,0,0,0,.94-2.9c.462-1.127.878-2.27,1.32-3.405A2.155,2.155,0,0,1,4.555-7.9q3.938-.017,7.877,0a2.19,2.19,0,0,1,2.379,1.671c.32.83.65,1.657.967,2.487a2.677,2.677,0,0,0,1.264,1.718,2.137,2.137,0,0,1,.92,1.538c.117,1.721.043,3.457.043,5.257H16.474c0,.6.01,1.122,0,1.651-.022.967-.552,1.567-1.354,1.559s-1.31-.613-1.325-1.585c-.006-.509,0-1.018,0-1.565H3.26c0,.6.013,1.156,0,1.712A1.354,1.354,0,0,1,1.929,7.978,1.327,1.327,0,0,1,.593,6.624C.559,6.045.586,5.462.586,4.789M14.868-2.454c-.478-1.262-.89-2.479-1.418-3.643a1.284,1.284,0,0,0-.992-.485q-3.94-.06-7.883,0a1.217,1.217,0,0,0-.942.448c-.536,1.18-.967,2.41-1.458,3.68ZM16.491.4A1.41,1.41,0,1,0,13.672.375a1.432,1.432,0,0,0,1.435,1.48A1.423,1.423,0,0,0,16.491.4M3.38.385A1.438,1.438,0,0,0,1.954-1.054,1.453,1.453,0,0,0,.561.422,1.445,1.445,0,0,0,1.99,1.861,1.442,1.442,0,0,0,3.38.385"
            transform="translate(0.968 7.908)"
            fill="#47494f"
          />
        </svg>
      ) : props.name === IconName.CHECK_MARK ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18.395"
          height="13.796"
          viewBox="0 0 18.395 13.796"
        >
          <path
            id="checked"
            d="M0,71.928l6.3,6.311,12.1-12.084-1.737-1.712L6.3,74.79,1.712,70.2Z"
            transform="translate(0 -64.443)"
            fill="currentColor"
          />
        </svg>
      ) : props.name === IconName.CHECK_MARK_CIRCLE ? (
        <svg
          id="Group_2705"
          data-name="Group 2705"
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
        >
          <path
            id="Path_2912"
            data-name="Path 2912"
            d="M129.865,161.518l-2.294-2.71-8.174,7.983-4.072-4.374-2.411,2.59,6.371,6.845Z"
            transform="translate(-106.02 -149.783)"
            fill="#fff"
          />
          <g id="Group_2704" data-name="Group 2704">
            <path
              id="Path_2913"
              data-name="Path 2913"
              d="M119.4,166.791l-4.072-4.374-2.411,2.59,6.371,6.845,10.58-10.334-2.294-2.71Z"
              transform="translate(-106.02 -149.783)"
              fill="none"
            />
            <path
              id="Path_2914"
              data-name="Path 2914"
              d="M15,0A15,15,0,1,0,30,15,15.059,15.059,0,0,0,15,0ZM13.185,21.823,6.616,15.254,9.1,12.768l4.2,4.2,8.428-7.661,2.365,2.6Z"
              fill="#b62427"
            />
          </g>
        </svg>
      ) : props.name === IconName.CHECK_MARK_CIRCLE_OUTLINE ? (
        <svg
          id="check"
          xmlns="http://www.w3.org/2000/svg"
          width="36"
          height="36"
          viewBox="0 0 36 36"
        >
          <g id="Group_2473" data-name="Group 2473">
            <g id="Group_2472" data-name="Group 2472">
              <path
                id="Path_2786"
                data-name="Path 2786"
                d="M18,0A18,18,0,1,0,36,18,18.02,18.02,0,0,0,18,0Zm0,33.211A15.211,15.211,0,1,1,33.211,18,15.229,15.229,0,0,1,18,33.211Z"
                fill="currentColor"
              />
            </g>
          </g>
          <g
            id="Group_2475"
            data-name="Group 2475"
            transform="translate(9.287 11.378)"
          >
            <g id="Group_2474" data-name="Group 2474">
              <path
                id="Path_2787"
                data-name="Path 2787"
                d="M149.051,162.185a1.4,1.4,0,0,0-1.969.095l-8.505,9.365-4.109-4.177a1.394,1.394,0,1,0-1.988,1.955l5.143,5.229a1.392,1.392,0,0,0,.994.417h.027a1.4,1.4,0,0,0,1.005-.457l9.5-10.457A1.4,1.4,0,0,0,149.051,162.185Z"
                transform="translate(-132.079 -161.824)"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      ) : props.name === IconName.CHEVRON_DOWN ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9.056"
          height="5.596"
          viewBox="0 0 9.056 5.596"
        >
          <g id="down-chevron" transform="translate(-270)">
            <g id="Group_48" data-name="Group 48" transform="translate(270 0)">
              <path
                id="Path_485"
                data-name="Path 485"
                d="M7.988,48.907l-3.46,3.46-3.46-3.46L0,49.975,4.528,54.5l4.528-4.528Z"
                transform="translate(0 -48.907)"
                fill="#292929"
              />
            </g>
          </g>
        </svg>
      ) : props.name === IconName.CHEVRON_UP_WHITE ? (
        <svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.5 11L6.5 6L11.5 11" strokeWidth="1.5" />
        </svg>
      ) : props.name === IconName.COUCH ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="23.091"
          height="15.584"
          viewBox="0 0 23.091 15.584"
        >
          <path
            id="Path_769"
            data-name="Path 769"
            d="M10.285,6.431V-2.583s0-1.147-1.037-1.147H7.422A1.053,1.053,0,0,0,6.385-2.583V3.291H-8.906V-2.583s0-1.147-1.035-1.147h-1.828a1.053,1.053,0,0,0-1.037,1.147V6.431s0,1.147,1.037,1.147h1.828a1.044,1.044,0,0,0,1.028-1H6.4a1.025,1.025,0,0,0,1.024,1H9.248a1.053,1.053,0,0,0,1.037-1.147M5.451,2.209c0-.777.029-1.495-.007-2.207C5.413-.58,5.1-.966,4.558-.971,2.591-.988-4.932-.988-7.1-.971a.879.879,0,0,0-.889.9C-8.035.677-8,1.436-8,2.213l13.448,0M5.451-2c0-1.628.016-3.316-.007-5a.941.941,0,0,0-1.06-1c-2.2-.014-11.4.009-11.47.009a.884.884,0,0,0-.9.952C-8.02-5.331-8-3.62-8-2L5.451-2"
            transform="translate(12.806 8.007)"
            fill="#47494f"
          />
        </svg>
      ) : props.name === IconName.DIAMOND ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31.572"
          height="28.031"
          viewBox="0 0 31.572 28.031"
        >
          <g id="diamond" transform="translate(0.107 -28.871)">
            <g
              id="Group_596"
              data-name="Group 596"
              transform="translate(0 28.96)"
            >
              <path
                id="Path_852"
                data-name="Path 852"
                d="M31.26,37.026c-5.428-6.96-5.2-6.785-5.486-6.814l-8.5-1.144a14.716,14.716,0,0,0-4.34.154.456.456,0,0,0,.122.9,13.955,13.955,0,0,1,4.1-.154l5.835.786-7.312,1.49-7.312-1.49,2.528-.34a.456.456,0,0,0-.122-.9l-5.189.7H5.574l-.021,0-.013,0-.011,0-.015,0-.024.007-.01,0,0,0-.014.005-.024.011-.01,0-.011.006-.011.006c-.2.115-.1.123-5.309,6.754a.456.456,0,0,0-.048.485c.183.364-.3-.354,9.749,12.99a.456.456,0,1,0,.727-.549l-8.83-11.7L8.83,40.5l5.494,14.491L11.81,51.655a.456.456,0,1,0-.727.549c2.633,3.489,2.9,3.85,2.923,3.871a2.164,2.164,0,0,0,1.233.686c.065.011.828.011.892,0a2.148,2.148,0,0,0,1.245-.712l8.892-11.786a.456.456,0,0,0-.727-.549L17.032,54.988,22.527,40.5l7.135-2.247L26.82,42.016a.456.456,0,0,0,.727.549c3.816-5.062,3.61-4.755,3.761-5.053A.456.456,0,0,0,31.26,37.026ZM15.678,33.4l5.5,6.27H10.182ZM1.172,37.129l4.322-5.542,2.93,7.826ZM6.35,31.276,14.819,33,9.337,39.255Zm9.379,24.582h-.1L9.837,40.584H21.519Zm6.291-16.6L16.538,33l8.469-1.726Zm.914.158,2.93-7.826,4.322,5.542Z"
                transform="translate(0 -28.96)"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="0.2"
              />
            </g>
          </g>
        </svg>
      ) : props.name === IconName.DISCOUNT ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="34.576"
          height="35.859"
          viewBox="0 0 34.576 35.859"
        >
          <g id="discount" transform="translate(-5.83 -4.749)">
            <path
              id="path871"
              d="M35.13,21.216a.982.982,0,0,0-1.388.021l-8.8,8.8a.982.982,0,1,0,1.389,1.389l8.8-8.8a.982.982,0,0,0,0-1.41ZM24.018,32.327a.982.982,0,0,0-1.388.021l-1.389,1.389a.982.982,0,1,0,1.389,1.389l1.389-1.389a.982.982,0,0,0,0-1.41Z"
              transform="translate(-5.141 -5.503)"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="0.5"
            />
            <path
              id="path873"
              d="M36.274,34a3.274,3.274,0,1,0,3.274,3.274A3.289,3.289,0,0,0,36.274,34Zm0,1.964a1.309,1.309,0,1,1-1.309,1.309A1.295,1.295,0,0,1,36.274,35.964Z"
              transform="translate(-9.3 -10.012)"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="0.5"
            />
            <path
              id="circle875"
              d="M24.274,20a3.274,3.274,0,1,0,3.274,3.274A3.289,3.289,0,0,0,24.274,20Zm0,1.964a1.309,1.309,0,1,1-1.309,1.309A1.295,1.295,0,0,1,24.274,21.964Z"
              transform="translate(-5.157 -5.179)"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="0.5"
            />
            <path
              id="path818"
              d="M23.046,5c-1.949.223-3.163,2.07-4.823,2.929-1.851.277-3.919-.513-5.633.447C11.152,9.7,11.253,11.9,10.421,13.563c-1.335,1.3-3.47,1.873-4.292,3.652-.381,1.918,1,3.627,1.313,5.463-.314,1.835-1.694,3.545-1.313,5.463.82,1.78,2.958,2.347,4.292,3.652.831,1.668.73,3.862,2.169,5.187,1.714.96,3.782.17,5.633.447,1.661.857,2.873,2.706,4.823,2.929,1.949-.224,3.161-2.072,4.821-2.929,1.864-.337,3.882.263,5.664-.46a.984.984,0,0,0-.866-1.724c-2.266.451-4.954-.589-6.832,1.172-.972.522-2.035,2.122-3.046,1.854-1.85-.979-3.257-3.213-5.611-2.849-1.094-.145-2.9.53-3.561-.279-.916-1.873-.737-4.5-2.855-5.583C9.961,28.8,8.1,28.3,8.046,27.252c.363-2.051,2.068-4.065.993-6.184-.2-1.078-1.4-2.578-.834-3.452,1.506-1.447,4.073-2.075,4.46-4.423.478-.989.393-2.908,1.369-3.279,2.075-.289,4.525.7,6.223-.973.971-.523,2.035-2.12,3.047-1.854,1.85.979,3.257,3.212,5.611,2.85,1.094.145,2.9-.53,3.561.279.919,1.872.735,4.5,2.855,5.582.8.758,2.657,1.264,2.715,2.307-.364,2.051-2.068,4.064-.993,6.183.2,1.079,1.4,2.578.834,3.453-1.446,1.415-3.919,2-4.411,4.208-.328.675-.51,1.855.448,2.1.937.264,1.364-.814,1.476-1.54.454-1.542,2.333-1.913,3.4-2.959a2.738,2.738,0,0,0,.938-3.621c-.426-1.555-1.651-3.154-.635-4.744.459-1.476,1.608-3.3.432-4.717-1.122-1.179-2.663-1.83-3.868-2.906C34.837,11.9,34.938,9.7,33.5,8.377c-1.714-.96-3.782-.17-5.633-.447C26.214,7.078,24.987,5.216,23.046,5Z"
              fill="currentColor"
              stroke="currentColor"
              strokeWidth="0.5"
            />
          </g>
        </svg>
      ) : props.name === IconName.FLIP ? (
        <svg
          id="Group_1389"
          data-name="Group 1389"
          xmlns="http://www.w3.org/2000/svg"
          width="35.829"
          height="39.625"
          viewBox="0 0 35.829 39.625"
        >
          <path
            id="Path_1691"
            data-name="Path 1691"
            d="M2.449,138.591a1.161,1.161,0,0,0-1.949.853v21.582a1.161,1.161,0,0,0,1.949.853l11.672-10.791a1.162,1.162,0,0,0,0-1.705Zm.373,19.78V142.1l8.8,8.136Zm0,0"
            transform="translate(-0.5 -127.581)"
            fill="#1c1b1b"
          />
          <path
            id="Path_1692"
            data-name="Path 1692"
            d="M295.931,138.378a1.161,1.161,0,0,0-1.253.211L283.006,149.38a1.162,1.162,0,0,0,0,1.705l11.672,10.791a1.161,1.161,0,0,0,1.949-.853V139.442A1.162,1.162,0,0,0,295.931,138.378ZM294.3,158.369l-8.8-8.136,8.8-8.136Zm0,0"
            transform="translate(-260.798 -127.579)"
            fill="#1c1b1b"
          />
          <path
            id="Path_1693"
            data-name="Path 1693"
            d="M218.137,438.984a1.161,1.161,0,0,0-1.161,1.161v3.328a1.161,1.161,0,1,0,2.322,0v-3.328A1.161,1.161,0,0,0,218.137,438.984Zm0,0"
            transform="translate(-200.223 -405.011)"
            fill="#1c1b1b"
          />
          <path
            id="Path_1694"
            data-name="Path 1694"
            d="M218.137,192.934a1.161,1.161,0,0,0-1.161,1.161v3.328a1.161,1.161,0,1,0,2.322,0v-3.328A1.161,1.161,0,0,0,218.137,192.934Zm0,0"
            transform="translate(-200.223 -178.002)"
            fill="#1c1b1b"
          />
          <path
            id="Path_1695"
            data-name="Path 1695"
            d="M218.137,315.961a1.161,1.161,0,0,0-1.161,1.161v3.328a1.161,1.161,0,1,0,2.322,0v-3.328A1.161,1.161,0,0,0,218.137,315.961Zm0,0"
            transform="translate(-200.223 -291.508)"
            fill="#1c1b1b"
          />
          <path
            id="Path_1696"
            data-name="Path 1696"
            d="M218.137,69.91a1.161,1.161,0,0,0-1.161,1.161V74.4a1.161,1.161,0,1,0,2.322,0V71.071A1.161,1.161,0,0,0,218.137,69.91Zm0,0"
            transform="translate(-200.223 -64.5)"
            fill="#1c1b1b"
          />
          <path
            id="Path_1697"
            data-name="Path 1697"
            d="M50.07,8a1.161,1.161,0,0,0,1.638-.119A16.027,16.027,0,0,1,74.76,6.619h-.205a1.161,1.161,0,1,0,0,2.322h2.883A1.161,1.161,0,0,0,78.6,7.78V4.9a1.16,1.16,0,0,0-2.32-.036,18.347,18.347,0,0,0-26.328,1.5A1.161,1.161,0,0,0,50.07,8Zm0,0"
            transform="translate(-45.862)"
            fill="#1c1b1b"
          />
        </svg>
      ) : props.name === IconName.FAN ? (
        <svg
          id="fan"
          xmlns="http://www.w3.org/2000/svg"
          width="33.954"
          height="33.954"
          viewBox="0 0 33.954 33.954"
        >
          <g id="Group_598" data-name="Group 598" transform="translate(0 0)">
            <g id="Group_597" data-name="Group 597">
              <path
                id="Path_873"
                data-name="Path 873"
                d="M28.981,4.972A16.977,16.977,0,0,0,4.972,28.981,16.977,16.977,0,0,0,28.981,4.972Zm-.7,23.306a15.982,15.982,0,0,1-22.6-22.6,15.982,15.982,0,0,1,22.6,22.6Z"
                transform="translate(0 0)"
                fill="currentColor"
              />
            </g>
          </g>
          <g
            id="Group_600"
            data-name="Group 600"
            transform="translate(3.061 2.658)"
          >
            <g id="Group_599" data-name="Group 599">
              <path
                id="Path_874"
                data-name="Path 874"
                d="M73.931,50.672a14.326,14.326,0,0,0-1.42-3.408l-.024-.042a3.885,3.885,0,0,0-3.046-1.944,4.061,4.061,0,0,0-.516-.013,12.833,12.833,0,0,0-4.136-2.685,1.575,1.575,0,0,0-.093-1.254,1.546,1.546,0,0,0-.968-.772,14.326,14.326,0,0,0-3.661-.475,3.919,3.919,0,0,0-3.234,1.681,4.1,4.1,0,0,0-.247.4,12.587,12.587,0,0,0-4.429,2.275l0,0a1.574,1.574,0,0,0-1.135-.55,1.544,1.544,0,0,0-1.153.452,14.329,14.329,0,0,0-2.242,2.933,3.919,3.919,0,0,0-.162,3.641,4.091,4.091,0,0,0,.248.456,12.79,12.79,0,0,0-.227,4.922l-.05.009A1.574,1.574,0,0,0,46.39,57a1.546,1.546,0,0,0-.185,1.224,14.327,14.327,0,0,0,1.42,3.408l.024.042a3.885,3.885,0,0,0,3.046,1.944q.186.017.369.017c.083,0,.165,0,.247-.008a12.834,12.834,0,0,0,4.067,2.6l-.03.084a1.575,1.575,0,0,0,.091,1.258,1.546,1.546,0,0,0,.968.772,14.329,14.329,0,0,0,3.661.475A3.919,3.919,0,0,0,63.3,67.138a4.076,4.076,0,0,0,.308-.516,12.6,12.6,0,0,0,4.318-2.217l.054.064a1.574,1.574,0,0,0,1.135.55h.059a1.545,1.545,0,0,0,1.094-.453,14.329,14.329,0,0,0,2.242-2.933,3.919,3.919,0,0,0,.162-3.641,4.084,4.084,0,0,0-.266-.484,12.789,12.789,0,0,0,.259-4.9L72.7,52.6a1.574,1.574,0,0,0,1.044-.708A1.546,1.546,0,0,0,73.931,50.672Zm-9.475-7.153a11.834,11.834,0,0,1,3.257,1.986,3.857,3.857,0,0,0-1.055.595,10.541,10.541,0,0,0-2.581-1.513Zm1.5,3.291-4.561,5.348,2.353-6.632A9.546,9.546,0,0,1,65.953,46.81Zm-8.306-4.476a2.935,2.935,0,0,1,2.422-1.259,13.33,13.33,0,0,1,3.406.442.541.541,0,0,1,.343.275.577.577,0,0,1,.034.461L60.279,52.317a2.1,2.1,0,0,0-.422,0l-2.583-7.279A2.936,2.936,0,0,1,57.646,42.334ZM61.166,54.4a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,61.166,54.4Zm-2.421-2.241L54.184,46.81a9.548,9.548,0,0,1,2.208-1.285Zm-2.576-8.824a3.889,3.889,0,0,0-.028,1.22,10.54,10.54,0,0,0-2.6,1.5l-.735-.862A11.6,11.6,0,0,1,56.169,43.334Zm-7.683,4.428a13.334,13.334,0,0,1,2.085-2.729.54.54,0,0,1,.409-.159.577.577,0,0,1,.416.2l6.946,8.143a2.1,2.1,0,0,0-.2.353l-7.625-1.408a2.971,2.971,0,0,1-2.036-4.4ZM49.576,55.9l-1.114.206a11.8,11.8,0,0,1,.065-3.806,3.891,3.891,0,0,0,1.046.621,10.667,10.667,0,0,0,0,2.979Zm1.208,6.731a2.9,2.9,0,0,1-2.275-1.452l-.024-.041a13.331,13.331,0,0,1-1.321-3.171.541.541,0,0,1,.067-.434.577.577,0,0,1,.383-.26l3.507-.648a.5.5,0,1,0-.181-.978l-.385.071a9.674,9.674,0,0,1-.013-2.539l6.879,1.27-4.355.8a.5.5,0,1,0,.181.978l4.942-.913a2.09,2.09,0,0,0,.192.316l-5.1,5.976A2.9,2.9,0,0,1,50.785,62.629Zm7.96-5.889-2.322,6.545a9.551,9.551,0,0,1-2.187-1.258Zm-3.034,8.55a11.835,11.835,0,0,1-3.206-1.928,3.867,3.867,0,0,0,1.035-.615,10.545,10.545,0,0,0,2.549,1.476Zm6.779,1.273a2.935,2.935,0,0,1-2.422,1.259,13.33,13.33,0,0,1-3.406-.442.541.541,0,0,1-.343-.275.577.577,0,0,1-.034-.461l3.606-10.163c.058,0,.117.008.176.008s.118,0,.176-.008l2.617,7.376A2.936,2.936,0,0,1,62.49,66.565Zm-1.1-9.824,4.51,5.287a9.544,9.544,0,0,1-2.187,1.258Zm2.594,8.717a3.9,3.9,0,0,0,0-1.209,10.534,10.534,0,0,0,2.565-1.463l.735.862A11.609,11.609,0,0,1,63.986,65.458Zm7.665-4.322a13.334,13.334,0,0,1-2.085,2.729.541.541,0,0,1-.409.159.577.577,0,0,1-.416-.2l-6.985-8.189a2.1,2.1,0,0,0,.192-.316l7.668,1.416a2.971,2.971,0,0,1,2.036,4.4ZM70.573,53l1.114-.206a11.793,11.793,0,0,1-.1,3.8,3.894,3.894,0,0,0-1.043-.613A10.667,10.667,0,0,0,70.573,53ZM72.9,51.367a.577.577,0,0,1-.383.26l-3.507.648a.5.5,0,1,0,.181.978l.4-.074a9.687,9.687,0,0,1-.013,2.539l-6.866-1.268,4.354-.8a.5.5,0,0,0-.181-.978l-4.9.9a2.087,2.087,0,0,0-.2-.353l5.059-5.93a2.936,2.936,0,0,1,4.774.433l.024.041a13.332,13.332,0,0,1,1.321,3.171A.541.541,0,0,1,72.9,51.367Z"
                transform="translate(-46.152 -40.08)"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      ) : props.name === IconName.FANCYBOX_CLOSE ? (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            fill="#000"
            d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"
          ></path>
        </svg>
      ) : props.name === IconName.FULLSCREEN ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43.381"
          height="43.381"
          viewBox="0 0 43.381 43.381"
        >
          <g
            id="Group_1388"
            data-name="Group 1388"
            transform="translate(-13.304 -13.309)"
          >
            <path
              id="Path_1683"
              data-name="Path 1683"
              d="M15.047,25.326H13.838V14.443a.6.6,0,0,1,.6-.6H25.326v1.209H15.047Z"
              transform="translate(0 0)"
              fill="#b62427"
              stroke="#b62427"
              strokeWidth="1"
            />
            <path
              id="Path_1684"
              data-name="Path 1684"
              d="M15.852,16.735l.855-.855L33.634,32.807l-.855.855Z"
              transform="translate(-1.838 -1.864)"
              fill="#b62427"
              stroke="#b62427"
              strokeWidth="1"
            />
            <path
              id="Path_1685"
              data-name="Path 1685"
              d="M378.191,25.326h-1.209V15.047H366.7V13.838h10.883a.6.6,0,0,1,.6.6Z"
              transform="translate(-322.029 0)"
              fill="#b62427"
              stroke="#b62427"
              strokeWidth="1"
            />
            <path
              id="Path_1686"
              data-name="Path 1686"
              d="M292.581,32.834l16.927-16.927.855.855L293.436,33.689Z"
              transform="translate(-254.384 -1.888)"
              fill="#b62427"
              stroke="#b62427"
              strokeWidth="1"
            />
            <path
              id="Path_1687"
              data-name="Path 1687"
              d="M25.326,378.191H14.443a.6.6,0,0,1-.6-.6V366.7h1.209v10.279H25.326Z"
              transform="translate(0 -322.029)"
              fill="#b62427"
              stroke="#b62427"
              strokeWidth="1"
            />
            <path
              id="Path_1688"
              data-name="Path 1688"
              d="M15.824,309.536l16.927-16.927.855.855L16.679,310.391Z"
              transform="translate(-1.812 -254.41)"
              fill="#b62427"
              stroke="#b62427"
              strokeWidth="1"
            />
            <path
              id="Path_1689"
              data-name="Path 1689"
              d="M377.586,378.191H366.7v-1.209h10.279V366.7h1.209v10.883A.6.6,0,0,1,377.586,378.191Z"
              transform="translate(-322.029 -322.029)"
              fill="#b62427"
              stroke="#b62427"
              strokeWidth="1"
            />
            <path
              id="Path_1690"
              data-name="Path 1690"
              d="M292.553,293.491l.855-.855,16.927,16.927-.855.855Z"
              transform="translate(-254.359 -254.435)"
              fill="#b62427"
              stroke="#b62427"
              strokeWidth="1"
            />
          </g>
        </svg>
      ) : props.name === IconName.HOUSE_ACREAGE ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="98.233"
          height="47.903"
          viewBox="0 0 98.233 47.903"
        >
          <g
            id="Group_2940"
            data-name="Group 2940"
            transform="translate(-679.958 -995.529)"
          >
            <g
              id="Group_2939"
              data-name="Group 2939"
              transform="translate(681.112 1014.162)"
            >
              <path
                id="Path_3090"
                data-name="Path 3090"
                d="M685.617,1016.883v20.307H770v-20.307"
                transform="translate(-679.949 -1008.92)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="Path_3091"
                data-name="Path 3091"
                d="M777.024,1019.115l-45.439-8.562-50.474,8.562"
                transform="translate(-681.112 -1010.553)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="Path_3092"
                data-name="Path 3092"
                d="M697.707,1020.421l16.79-5.961h-.1l16.79,5.961"
                transform="translate(-676.831 -1009.545)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="Path_3093"
                data-name="Path 3093"
                d="M726.977,1035.273V1022.38h25.946v12.827"
                transform="translate(-669.28 -1007.502)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <rect
                id="Rectangle_352"
                data-name="Rectangle 352"
                width="7.71"
                height="9.682"
                transform="translate(12.251 14.878)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="Path_3094"
                data-name="Path 3094"
                d="M707.182,1035.542v-12.27h9.643v12.27"
                transform="translate(-674.386 -1007.272)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <line
                id="Line_168"
                data-name="Line 168"
                y2="18.092"
                transform="translate(49.68 9.517)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <line
                id="Line_169"
                data-name="Line 169"
                y2="18.092"
                transform="translate(25.835 9.517)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </g>
            <path
              id="Path_3095"
              data-name="Path 3095"
              d="M757.409,1020.814a4.022,4.022,0,0,0,1.42-6.749.75.75,0,1,1-.062-1.405,4.024,4.024,0,0,0-2.048-6.572,3.864,3.864,0,0,0-1.215-.074,3.8,3.8,0,0,0,.477-1.121,4.025,4.025,0,0,0-4.988-4.756.743.743,0,1,1-1.223-.682,4.026,4.026,0,0,0-6.67-1.74,3.8,3.8,0,0,0-.7.995,3.855,3.855,0,0,0-.7-.994,4.024,4.024,0,0,0-6.666,1.716.75.75,0,1,1-1.227.687,4.021,4.021,0,0,0-4.993,4.758.749.749,0,1,1-.742,1.19,4.022,4.022,0,0,0-2.043,6.582.75.75,0,1,1-.072,1.405,3.833,3.833,0,0,0-.639.752"
              transform="translate(11.324 0)"
              fill="none"
              stroke="#1a1818"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      ) : props.name === IconName.HOUSE_DOUBLE_STORY ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="75.279"
          height="60.62"
          viewBox="0 0 75.279 60.62"
        >
          <g
            id="Group_4243"
            data-name="Group 4243"
            transform="translate(-443.605 -992.561)"
          >
            <line
              id="Line_164"
              data-name="Line 164"
              x2="42.775"
              y2="15.616"
              transform="translate(474.827 993.844)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <line
              id="Line_165"
              data-name="Line 165"
              y2="57.205"
              transform="translate(477.931 994.977)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_3089"
              data-name="Path 3089"
              d="M512.781,1004.186V1047.4H448.057"
              transform="translate(1.466 4.78)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <line
              id="Line_166"
              data-name="Line 166"
              y1="33.25"
              transform="translate(449.523 1018.932)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <rect
              id="Rectangle_349"
              data-name="Rectangle 349"
              width="19.338"
              height="11.198"
              transform="translate(486.621 1014.344)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <rect
              id="Rectangle_350"
              data-name="Rectangle 350"
              width="22.594"
              height="19.536"
              transform="translate(484.746 1032.646)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <rect
              id="Rectangle_351"
              data-name="Rectangle 351"
              width="8.88"
              height="19.536"
              transform="translate(459.287 1032.646)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <line
              id="Line_167"
              data-name="Line 167"
              y1="11.938"
              x2="33.045"
              transform="translate(444.886 1008.375)"
              fill="none"
              stroke="#000"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      ) : props.name === IconName.HOUSE_KEYS ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="37.854"
          height="31.999"
          viewBox="0 0 37.854 31.999"
        >
          <g id="house-key" transform="translate(0 -39.594)">
            <g
              id="Group_602"
              data-name="Group 602"
              transform="translate(0 39.594)"
            >
              <g id="Group_601" data-name="Group 601">
                <path
                  id="Path_875"
                  data-name="Path 875"
                  d="M352.965,424.907H348.8a.5.5,0,1,0,0,1h4.169a.5.5,0,1,0,0-1Z"
                  transform="translate(-322.547 -396.419)"
                  fill="currentColor"
                />
                <path
                  id="Path_876"
                  data-name="Path 876"
                  d="M348.8,400.843h2.779a.5.5,0,1,0,0-1H348.8a.5.5,0,1,0,0,1Z"
                  transform="translate(-322.547 -373.212)"
                  fill="currentColor"
                />
                <path
                  id="Path_877"
                  data-name="Path 877"
                  d="M352.965,374.782H348.8a.5.5,0,0,0,0,1h4.169a.5.5,0,0,0,0-1Z"
                  transform="translate(-322.547 -350)"
                  fill="currentColor"
                />
                <path
                  id="Path_878"
                  data-name="Path 878"
                  d="M36.251,58.834a4.061,4.061,0,0,0-.779-2.409l-.566-.766A9.288,9.288,0,1,0,20.418,44.406a11.683,11.683,0,0,0-6.91,1.388,4.413,4.413,0,0,0-2.492,3.587s0,.007,0,.011v.019c0,.008,0,.015,0,.023s0,.013,0,.02v1.937l-1.32.792a.5.5,0,0,0-.21.252l-.324.862-2.037.049a.5.5,0,0,0-.486.478L6.6,54.838l-2.3.055a.5.5,0,0,0-.486.478L3.761,56.54,1.295,56.6a.5.5,0,0,0-.244.071l-.81.486A.5.5,0,0,0,0,57.6l.061,2.55v2.067s0,0,0,.007v.009a.471.471,0,0,0,.01.049.5.5,0,0,0,.028.14.473.473,0,0,0,.037.058.5.5,0,0,0,.067.1.5.5,0,0,0,.073.052.487.487,0,0,0,.082.056.5.5,0,0,0,.112.026.472.472,0,0,0,.073.017H.561l4.327.129H4.9c.006,0,.012,0,.018,0a.49.49,0,0,0,.151-.03.463.463,0,0,0,.048-.021c.014-.007.028-.01.041-.018L16.641,55.9a12.247,12.247,0,0,0,1.668.118,12.456,12.456,0,0,0,3.675-.553,9.07,9.07,0,0,0,1.831,1.424,4.108,4.108,0,0,0-.494,1.949V69.72a1.8,1.8,0,0,0,1.717,1.874h9.5a1.8,1.8,0,0,0,1.716-1.874V58.834ZM20.387,47.4a8.094,8.094,0,0,1,.756-2.25,8.3,8.3,0,1,1,12.776,10.07h0a8.189,8.189,0,0,1-3.078,1.652,8.1,8.1,0,0,1-1.772.3.874.874,0,0,1-.1-.857,7.443,7.443,0,1,0-6.81-11.241,7.317,7.317,0,0,0-.918,2.406,7.1,7.1,0,0,0-.12,1.082,2.156,2.156,0,0,1-.86.161A7.89,7.89,0,0,1,20.387,47.4ZM24.3,45.545h0a7.386,7.386,0,0,0-.943-.452A6.439,6.439,0,1,1,33.2,53.348l-1.388-1.879a2.52,2.52,0,0,0-2.026-1.06h0A2.52,2.52,0,0,0,27.76,51.47l-2.284,3.093a6.36,6.36,0,0,1-.734-.47,4.106,4.106,0,0,0,1.807-3.073V48.945A3.882,3.882,0,0,0,24.3,45.545ZM4.4,61.846l-3.345-.1V60.66l3.345.1Zm.367-2.072-3.724-.111L1,57.864l.448-.269,2.8-.071a.5.5,0,0,0,.485-.478l.047-1.168,2.3-.055a.5.5,0,0,0,.486-.478l.041-1.014,1.906-.045a.5.5,0,0,0,.454-.323l.381-1.014,1.79-1.074a5.66,5.66,0,0,0,1.124.849c.036.021.076.039.113.06L3.909,58.467a.5.5,0,1,0,.513.854l10.057-6.034c.232.086.472.162.718.231ZM16.031,55.1,5.4,61.481v-.922l10.633-6.38V55.1Zm-2.263-3.238h0a3.013,3.013,0,0,1-1.759-2.418v-.039a3.519,3.519,0,0,1,2.011-2.758,10.714,10.714,0,0,1,5.931-1.282,9.113,9.113,0,0,0-.479,1.558,2.657,2.657,0,0,0-.491.218,1.4,1.4,0,0,0-.759,1.17,1.3,1.3,0,0,0,.709,1.09,2.24,2.24,0,0,0,.723.261,3.177,3.177,0,0,0,.644.065,3.007,3.007,0,0,0,1.516-.389l.05-.033a1.36,1.36,0,0,0,.712-1.093,1.145,1.145,0,0,0-.3-.8,6.31,6.31,0,0,1,.538-1.462,6.543,6.543,0,0,1,.983.453,2.961,2.961,0,0,1,1.756,2.524v.03a3.535,3.535,0,0,1-2,2.659,8.2,8.2,0,0,1-1.057.528,10.419,10.419,0,0,1-1.712.529l-.027,0A10.244,10.244,0,0,1,13.769,51.863Zm5.519-3.7c-.006.083-.007.169-.011.253a.187.187,0,0,1-.057-.112A.242.242,0,0,1,19.288,48.165Zm2.674,6.266a11.517,11.517,0,0,1-4.935.512V53.866a12.372,12.372,0,0,0,1.286.069,12.725,12.725,0,0,0,2.625-.273l.033-.006a11.437,11.437,0,0,0,1.9-.587,9.179,9.179,0,0,0,1.188-.594A6.39,6.39,0,0,0,25.521,51.3a3.73,3.73,0,0,1-1.907,2.361c-.016.012-.031.02-.062.04A8.366,8.366,0,0,1,21.962,54.431Zm1.057.651h0c.285-.124.564-.264.838-.416a7.4,7.4,0,0,0,1.022.706l-.507.687A8.026,8.026,0,0,1,23.02,55.081ZM34.535,70.6h-9.5a.812.812,0,0,1-.72-.878V58.834A3.081,3.081,0,0,1,24.911,57l3.65-4.942a1.472,1.472,0,0,1,2.451,0l1.443,1.954a6.32,6.32,0,0,1-1.8.968,1.9,1.9,0,0,0-2.207.337,1.644,1.644,0,0,0-.186.222,1.871,1.871,0,0,0,.188,2.444,1,1,0,0,0,.08.074,1.866,1.866,0,0,0,1.25.479,1.9,1.9,0,0,0,1.347-.562,2.1,2.1,0,0,0,.176-.211A9.161,9.161,0,0,0,34.144,56.3l.528.715a3.062,3.062,0,0,1,.583,1.816h0V69.72A.812.812,0,0,1,34.535,70.6Z"
                  transform="translate(0 -39.594)"
                  fill="currentColor"
                />
              </g>
            </g>
          </g>
        </svg>
      ) : props.name === IconName.HOUSE_LAND_PACKAGE ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="109.9"
          height="60.513"
          viewBox="0 0 109.9 60.513"
        >
          <g
            id="Group_2931"
            data-name="Group 2931"
            transform="translate(-181.352 -992.174)"
          >
            <g
              id="Group_2929"
              data-name="Group 2929"
              transform="translate(187.86 993.456)"
            >
              <line
                id="Line_150"
                data-name="Line 150"
                x2="42.342"
                y2="15.458"
                transform="translate(29.638)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <line
                id="Line_151"
                data-name="Line 151"
                y2="56.626"
                transform="translate(32.711 1.122)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <line
                id="Line_152"
                data-name="Line 152"
                y2="7.299"
                transform="translate(68.659 50.448)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <line
                id="Line_153"
                data-name="Line 153"
                y2="13.53"
                transform="translate(68.659 14.97)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <line
                id="Line_154"
                data-name="Line 154"
                y1="11.818"
                x2="32.711"
                transform="translate(0 14.384)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <line
                id="Line_155"
                data-name="Line 155"
                y1="32.913"
                transform="translate(4.59 24.834)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <rect
                id="Rectangle_347"
                data-name="Rectangle 347"
                width="19.143"
                height="11.085"
                transform="translate(41.313 20.292)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="Path_3077"
                data-name="Path 3077"
                d="M213.417,1039.331v-19.338h22.366v19.338"
                transform="translate(-173.96 -981.583)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="Path_3078"
                data-name="Path 3078"
                d="M196.006,1039.331v-19.338h8.79v19.338"
                transform="translate(-181.751 -981.583)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </g>
            <g
              id="Group_2930"
              data-name="Group 2930"
              transform="translate(253.367 1017.214)"
            >
              <path
                id="Path_3079"
                data-name="Path 3079"
                d="M250.907,1043.384v-6.125a34.76,34.76,0,0,1-5.877-.9c-1.792-.6-2.639-1.145-2.888-2.191a6.825,6.825,0,0,1,.847-3.883,7.289,7.289,0,0,0,1.045-3.338c-.1-.9-.3-2.589.4-3.634s1.777-1.643,2.06-2.49-.331-1.146,0-2.64a13.348,13.348,0,0,1,3.468-5.428c1.693-1.692,2.838-2.888,2.838-2.888"
                transform="translate(-226.644 -1009.87)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="Path_3080"
                data-name="Path 3080"
                d="M251.378,1043.384v-6.125a34.729,34.729,0,0,0,5.875-.9c1.793-.6,2.64-1.145,2.889-2.191a6.825,6.825,0,0,0-.847-3.883,7.3,7.3,0,0,1-1.047-3.338c.1-.9.3-2.589-.4-3.634s-1.776-1.643-2.058-2.49.331-1.146,0-2.64a13.353,13.353,0,0,0-3.469-5.428c-1.692-1.692-2.838-2.888-2.838-2.888"
                transform="translate(-223.33 -1009.87)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <line
                id="Line_156"
                data-name="Line 156"
                y2="6.474"
                transform="translate(14.228 27.04)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="Path_3081"
                data-name="Path 3081"
                d="M249.072,1016.382a4.131,4.131,0,0,0-7.292-1.3,4.131,4.131,0,0,0-6.8,3.157v.043a7.184,7.184,0,0,0,.563,13.169c.123,0,.243-.009.363-.019a4.13,4.13,0,0,0,6.373,2.682l.072,7.684"
                transform="translate(-231.415 -1008.288)"
                fill="none"
                stroke="#1c1b1b"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </g>
            <line
              id="Line_157"
              data-name="Line 157"
              x1="104.992"
              transform="translate(182.352 1051.687)"
              fill="none"
              stroke="#1c1b1b"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      ) : props.name === IconName.HOUSE_OUTLINE ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="39.632"
          height="33.573"
          viewBox="0 0 39.632 33.573"
        >
          <g
            id="Group_2782"
            data-name="Group 2782"
            transform="translate(-218.001 -223.81)"
          >
            <g
              id="Group_2781"
              data-name="Group 2781"
              transform="translate(218.001 223.811)"
            >
              <path
                id="Path_2941"
                data-name="Path 2941"
                d="M244.767,269.092v-1.006a.581.581,0,1,0-1.161,0v1.006a.581.581,0,0,0,1.161,0Z"
                transform="translate(-230.254 -244.719)"
                fill="currentColor"
              />
              <path
                id="Path_2942"
                data-name="Path 2942"
                d="M256.449,253.739a2.189,2.189,0,0,0-.23-.773,2.231,2.231,0,0,0-.784-.859.911.911,0,0,1-.4-.578A3,3,0,0,0,252.7,249.2v-8.676a.58.58,0,1,0-1.161,0V253.6H235.162V241.758h.116a.58.58,0,1,0,0-1.161h-9a.58.58,0,0,0,0,1.161h.116v7.72a.581.581,0,0,0,1.161,0v-7.72H234V253.6h-6.443v-1.428a.581.581,0,0,0-1.161,0V253.6h-2.305V235.075l13.6-6.816a.275.275,0,0,1,.246,0h0l13.6,6.816v2.732a.58.58,0,1,0,1.161,0v-2.15l1.109.556a1.436,1.436,0,0,0,2.078-1.283v-1.348a1.427,1.427,0,0,0-.792-1.283l-16.639-8.337a1.444,1.444,0,0,0-1.285,0L220.535,232.3a1.427,1.427,0,0,0-.792,1.283v1.348a1.435,1.435,0,0,0,2.078,1.283l1.109-.556V249.2a3,3,0,0,0-2.329,2.332.91.91,0,0,1-.4.578,2.234,2.234,0,0,0-.784.859,2.2,2.2,0,0,0-.23.773,1.891,1.891,0,0,0,.707,3.644h35.85a1.891,1.891,0,0,0,.707-3.644ZM252.7,250.4l.021.007a1.846,1.846,0,0,1,1.172,1.359,2.079,2.079,0,0,0,.915,1.32,1.065,1.065,0,0,1,.374.411,1,1,0,0,1,.045.1H252.7v-3.2Zm-31.4-15.226a.274.274,0,0,1-.4-.245v-1.348a.273.273,0,0,1,.152-.245L237.694,225a.275.275,0,0,1,.246,0l16.639,8.337a.273.273,0,0,1,.152.245v1.348a.274.274,0,0,1-.4.245l-15.873-7.953h0a1.44,1.44,0,0,0-1.286,0Zm-.854,18.323a1.063,1.063,0,0,1,.374-.411,2.077,2.077,0,0,0,.915-1.32,1.846,1.846,0,0,1,1.172-1.359l.021-.007v3.2H220.4A.962.962,0,0,1,220.447,253.5Zm35.295,2.724h-35.85a.73.73,0,0,1,0-1.459h35.85a.73.73,0,1,1,0,1.459Z"
                transform="translate(-218.001 -223.811)"
                fill="currentColor"
              />
              <path
                id="Path_2943"
                data-name="Path 2943"
                d="M256.752,256a1.245,1.245,0,0,0-1.244,1.244v4.326a1.246,1.246,0,0,0,1.244,1.244h9.189a1.246,1.246,0,0,0,1.244-1.244v-4.326A1.246,1.246,0,0,0,265.941,256Zm9.272,1.244v4.326a.083.083,0,0,1-.083.083h-9.189a.083.083,0,0,1-.083-.083v-4.326a.084.084,0,0,1,.083-.083h9.189a.083.083,0,0,1,.083.083Z"
                transform="translate(-235.949 -239.215)"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      ) : props.name === IconName.HOUSE_SINGLE_STORY ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="87.044"
          height="55.049"
          viewBox="0 0 87.044 55.049"
        >
          <g
            id="house_1_"
            data-name="house (1)"
            transform="translate(11.339 -4.36)"
          >
            <g
              id="Group_2937"
              data-name="Group 2937"
              transform="translate(-10.12 5.598)"
            >
              <path
                id="Path_3085"
                data-name="Path 3085"
                d="M322.432,1040.533"
                transform="translate(-314.303 -986.722)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <g
                id="Group_2936"
                data-name="Group 2936"
                transform="translate(0)"
              >
                <path
                  id="Path_3086"
                  data-name="Path 3086"
                  d="M320.479,1013.572v32.459h74.416v-32.459"
                  transform="translate(-315.48 -1002.961)"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <line
                  id="Line_162"
                  data-name="Line 162"
                  y1="11.568"
                  x2="44.513"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <line
                  id="Line_163"
                  data-name="Line 163"
                  x1="40.073"
                  y1="11.568"
                  transform="translate(44.514)"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <path
                  id="Path_3087"
                  data-name="Path 3087"
                  d="M345.418,1041.077v-20.608h26.224v20.5"
                  transform="translate(-300.459 -998.807)"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <rect
                  id="Rectangle_348"
                  data-name="Rectangle 348"
                  width="8.505"
                  height="15.475"
                  transform="translate(29.435 21.663)"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <path
                  id="Path_3088"
                  data-name="Path 3088"
                  d="M325.915,1041.876v-21.407h8.5v21.407"
                  transform="translate(-312.206 -998.807)"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
              </g>
            </g>
          </g>
        </svg>
      ) : props.name === IconName.KITCHEN ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="31.023"
          height="31.023"
          viewBox="0 0 31.023 31.023"
        >
          <g id="Layer_70" data-name="Layer 70" transform="translate(-6 -6)">
            <path
              id="Path_853"
              data-name="Path 853"
              d="M36.83,47.108H7V31H36.83ZM8.193,45.915H35.637V32.193H8.193Z"
              transform="translate(-0.403 -10.085)"
              fill="#fff"
            />
            <path
              id="Path_854"
              data-name="Path 854"
              d="M45.739,11.966H35V9.806l2.386-1.193V6h5.966V8.613l2.386,1.193Zm-9.546-1.193h8.352v-.227L42.159,9.353V7.193H38.58v2.16l-2.386,1.193Z"
              transform="translate(-11.698)"
              fill="#fff"
            />
            <path
              id="Path_855"
              data-name="Path 855"
              d="M45.739,47.756H35V40H45.739Zm-9.546-1.193h8.352V41.193H36.193Z"
              transform="translate(-11.698 -13.715)"
              fill="#fff"
            />
            <ellipse
              id="Ellipse_25"
              data-name="Ellipse 25"
              cx="1"
              cy="0.5"
              rx="1"
              ry="0.5"
              transform="translate(27.963 24.06)"
              fill="#fff"
            />
            <ellipse
              id="Ellipse_26"
              data-name="Ellipse 26"
              cx="1"
              cy="0.5"
              rx="1"
              ry="0.5"
              transform="translate(30.963 24.06)"
              fill="#fff"
            />
            <path
              id="Path_856"
              data-name="Path 856"
              d="M40.193,30.983H39V28h2.386v1.193H40.193Z"
              transform="translate(-13.312 -8.875)"
              fill="#fff"
            />
            <path
              id="Path_857"
              data-name="Path 857"
              d="M47.386,30.983H46.193v-1.79H45V28h2.386Z"
              transform="translate(-15.732 -8.875)"
              fill="#fff"
            />
            <path
              id="Path_858"
              data-name="Path 858"
              d="M23.529,46.739H11V36H23.529ZM12.193,45.546H22.335V37.193H12.193Z"
              transform="translate(-2.017 -12.102)"
              fill="#fff"
            />
            <path
              id="Path_859"
              data-name="Path 859"
              d="M11,44H23.529v1.193H11Z"
              transform="translate(-2.017 -15.329)"
              fill="#fff"
            />
            <path
              id="Path_860"
              data-name="Path 860"
              d="M19,40h2.386v1.193H19Z"
              transform="translate(-5.244 -13.715)"
              fill="#fff"
            />
            <path
              id="Path_861"
              data-name="Path 861"
              d="M19,48h2.386v1.193H19Z"
              transform="translate(-5.244 -16.943)"
              fill="#fff"
            />
            <path
              id="Path_862"
              data-name="Path 862"
              d="M42,43h2.386v1.193H42Z"
              transform="translate(-14.522 -14.926)"
              fill="#fff"
            />
            <path
              id="Path_863"
              data-name="Path 863"
              d="M23,9h4.176v1.193H23Z"
              transform="translate(-6.858 -1.21)"
              fill="#fff"
            />
            <path
              id="Path_864"
              data-name="Path 864"
              d="M12,9h7.756v1.193H12Z"
              transform="translate(-2.42 -1.21)"
              fill="#fff"
            />
            <path
              id="Path_865"
              data-name="Path 865"
              d="M9,9h2.983v1.193H9Z"
              transform="translate(-1.21 -1.21)"
              fill="#fff"
            />
            <path
              id="Path_866"
              data-name="Path 866"
              d="M12,7h1.193v8.949H12Z"
              transform="translate(-2.42 -0.403)"
              fill="#fff"
            />
            <path
              id="Path_867"
              data-name="Path 867"
              d="M23,7h1.193v5.966H23Z"
              transform="translate(-6.858 -0.403)"
              fill="#fff"
            />
            <path
              id="Path_868"
              data-name="Path 868"
              d="M11.79,23.58a1.79,1.79,0,1,1,1.79-1.79A1.79,1.79,0,0,1,11.79,23.58Zm0-2.386a.6.6,0,1,0,.6.6A.6.6,0,0,0,11.79,21.193Z"
              transform="translate(-1.614 -5.648)"
              fill="#fff"
            />
            <path
              id="Path_869"
              data-name="Path 869"
              d="M21.58,22.159a3.58,3.58,0,1,1,3.58-3.58A3.58,3.58,0,0,1,21.58,22.159Zm0-5.966a2.386,2.386,0,1,0,2.386,2.386A2.386,2.386,0,0,0,21.58,16.193Z"
              transform="translate(-4.841 -3.631)"
              fill="#fff"
            />
            <path
              id="Path_870"
              data-name="Path 870"
              d="M6,31H37.023v1.193H6Z"
              transform="translate(0 -10.085)"
              fill="#fff"
            />
          </g>
        </svg>
      ) : props.name === IconName.KNOCK_DOWN_REBUILD ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="87.225"
          height="79.011"
          viewBox="0 0 87.225 79.011"
        >
          <g
            id="Group_4238"
            data-name="Group 4238"
            transform="translate(-1297.779 -515.865)"
          >
            <g
              id="house_1_"
              data-name="house (1)"
              transform="translate(1309.117 534.402)"
            >
              <g
                id="Group_2936"
                data-name="Group 2936"
                transform="translate(-10.119 5.598)"
              >
                <path
                  id="Path_3086"
                  data-name="Path 3086"
                  d="M320.479,1013.572v32.459h39.748"
                  transform="translate(-315.48 -1002.961)"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <line
                  id="Line_162"
                  data-name="Line 162"
                  y1="11.568"
                  x2="44.513"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <rect
                  id="Rectangle_348"
                  data-name="Rectangle 348"
                  width="8.505"
                  height="15.475"
                  transform="translate(29.435 21.663)"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
                <path
                  id="Path_3088"
                  data-name="Path 3088"
                  d="M325.915,1041.876v-21.407h8.5v21.407"
                  transform="translate(-312.206 -998.807)"
                  fill="none"
                  stroke="#000"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                />
              </g>
            </g>
            <g
              id="Group_2938"
              data-name="Group 2938"
              transform="translate(866.113 -469.112)"
            >
              <line
                id="Line_164"
                data-name="Line 164"
                x2="39.214"
                y2="14.848"
                transform="translate(478.387 994.612)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <path
                id="Path_4116"
                data-name="Path 4116"
                d="M0-4V73.011"
                transform="translate(477.93 989.977)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeWidth="2"
                strokeDasharray="11"
              />
              <path
                id="Path_3089"
                data-name="Path 3089"
                d="M512.781,1004.186V1047.4H477.057"
                transform="translate(1.466 4.78)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <rect
                id="Rectangle_349"
                data-name="Rectangle 349"
                width="19.338"
                height="11.198"
                transform="translate(486.621 1014.344)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
              <rect
                id="Rectangle_350"
                data-name="Rectangle 350"
                width="22.594"
                height="19.536"
                transform="translate(484.746 1032.646)"
                fill="none"
                stroke="#000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </g>
          </g>
        </svg>
      ) : props.name === IconName.LOCATION ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24.131"
          height="28.527"
          viewBox="0 0 24.131 28.527"
        >
          <g id="location" transform="translate(-39.451)">
            <g
              id="Group_547"
              data-name="Group 547"
              transform="translate(39.451)"
            >
              <g id="Group_546" data-name="Group 546" transform="translate(0)">
                <path
                  id="Path_812"
                  data-name="Path 812"
                  d="M60.048,3.534a12.065,12.065,0,0,0-20.6,8.532c0,6.52,6.164,11.942,9.476,14.855.46.4.858.754,1.174,1.05a2.079,2.079,0,0,0,2.83,0c.317-.3.714-.645,1.174-1.05,3.312-2.913,9.476-8.336,9.476-14.855A11.987,11.987,0,0,0,60.048,3.534ZM53,25.666c-.47.414-.876.771-1.211,1.084a.4.4,0,0,1-.549,0c-.335-.313-.741-.67-1.211-1.084-3.113-2.739-8.909-7.837-8.909-13.6a10.394,10.394,0,0,1,20.789,0C61.911,17.829,56.115,22.927,53,25.666Z"
                  transform="translate(-39.451)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_549"
              data-name="Group 549"
              transform="translate(46.199 6.293)"
            >
              <g id="Group_548" data-name="Group 548">
                <path
                  id="Path_813"
                  data-name="Path 813"
                  d="M165.887,112.938a5.317,5.317,0,1,0,5.317,5.317A5.323,5.323,0,0,0,165.887,112.938Zm0,8.963a3.646,3.646,0,1,1,3.646-3.646A3.65,3.65,0,0,1,165.887,121.9Z"
                  transform="translate(-160.57 -112.938)"
                  fill="currentColor"
                />
              </g>
            </g>
          </g>
        </svg>
      ) : props.name === IconName.PARQUET ? (
        <svg
          id="parquet"
          xmlns="http://www.w3.org/2000/svg"
          width="27.887"
          height="32.061"
          viewBox="0 0 27.887 32.061"
        >
          <path
            id="Path_871"
            data-name="Path 871"
            d="M27.417,156.6H23.353v-4.508a.47.47,0,0,0-.47-.47h-7V144.4a.47.47,0,0,0-.939,0v7.222H10.9V140.107H14.94v2.411a.47.47,0,1,0,.939,0v-2.881a.469.469,0,0,0-.47-.47H.47a.469.469,0,0,0-.47.47c0,.444.006,13.78.007,15.759a.47.47,0,0,0,.939,0v-5.333H4.985v11.512H.946v-4.3a.47.47,0,1,0-.939,0v4.77a.47.47,0,0,0,.47.47H27.417a.469.469,0,0,0,.47-.47v-4.978A.469.469,0,0,0,27.417,156.6Zm-5-4.039V156.6H10.9v-4.039ZM5.924,156.6V145.085H9.962V156.6ZM.939,140.107H9.962v4.039H.939Zm0,9.016v-4.038H4.985v4.038Zm4.985,8.413H17.436v4.038H5.924Zm21.024,4.038H18.375v-4.038h8.572Zm0,0"
            transform="translate(0 -130.453)"
            fill="currentColor"
          />
          <path
            id="Path_872"
            data-name="Path 872"
            d="M244.425,0H231.974a.47.47,0,0,0-.47.47V5.447a.47.47,0,0,0,.47.47h7V17.9a.469.469,0,0,0,.47.47h4.978a.469.469,0,0,0,.47-.47V.47A.469.469,0,0,0,244.425,0ZM232.443.939h11.512V4.978H232.443Zm11.512,16.49h-4.038V5.917h4.038Zm0,0"
            transform="translate(-217.007)"
            fill="currentColor"
          />
        </svg>
      ) : props.name === IconName.PLANT ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="66.839"
          height="62.232"
          viewBox="0 0 66.839 62.232"
        >
          <g
            id="Group_2933"
            data-name="Group 2933"
            transform="translate(-69.391 -990.873)"
          >
            <path
              id="Path_3082"
              data-name="Path 3082"
              d="M95.9,1026.249s-1.194-12.426,6.692-17.445,14.816-3.344,14.816-3.344,1.433,10.753-5.019,16.487S95.9,1026.249,95.9,1026.249Z"
              transform="translate(11.126 5.823)"
              fill="none"
              stroke="#1a1818"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <line
              id="Line_158"
              data-name="Line 158"
              y1="49.444"
              transform="translate(102.013 1002.66)"
              fill="none"
              stroke="#1a1818"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <line
              id="Line_159"
              data-name="Line 159"
              x1="15.807"
              y2="16.727"
              transform="translate(102.013 1021.079)"
              fill="none"
              stroke="#1a1818"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <path
              id="Path_3083"
              data-name="Path 3083"
              d="M99.517,1022.855s-1.664-10.476-7.67-14.934c-4.675-3.472-15.743-2.735-15.743-2.735s-.323,10.262,6.608,15.458C88.451,1024.947,99.517,1022.855,99.517,1022.855Z"
              transform="translate(2.497 5.792)"
              fill="none"
              stroke="#1a1818"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <line
              id="Line_160"
              data-name="Line 160"
              x2="9.838"
              y2="7.554"
              transform="translate(92.175 1021.092)"
              fill="none"
              stroke="#1a1818"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
            <g
              id="Group_2932"
              data-name="Group 2932"
              transform="translate(96.846 991.873)"
            >
              <path
                id="Path_3084"
                data-name="Path 3084"
                d="M93.966,1012.079a11.239,11.239,0,0,0,4.97-9.483,16.409,16.409,0,0,0-4.175-10.723s-5.06,5.55-5.831,9.963C87.833,1008.113,93.966,1012.079,93.966,1012.079Z"
                transform="translate(-88.799 -991.873)"
                fill="none"
                stroke="#1a1818"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </g>
            <line
              id="Line_161"
              data-name="Line 161"
              x2="64.839"
              transform="translate(70.391 1052.105)"
              fill="none"
              stroke="#1a1818"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
            />
          </g>
        </svg>
      ) : props.name === IconName.RESTART ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22.775"
          height="22.775"
          viewBox="0 0 22.775 22.775"
        >
          <g id="refresh" transform="translate(-0.001)">
            <g
              id="Group_2701"
              data-name="Group 2701"
              transform="translate(1.257)"
            >
              <g id="Group_2700" data-name="Group 2700">
                <path
                  id="Path_2908"
                  data-name="Path 2908"
                  d="M48.948,3.142a.89.89,0,0,0-.967.805L47.863,5.24a11.23,11.23,0,0,0-19.528.937.89.89,0,0,0,1.585.809A9.458,9.458,0,0,1,46.374,6.2L45.105,5.3a.89.89,0,0,0-1.034,1.448l3.847,2.747a.89.89,0,0,0,1.4-.643l.432-4.739A.89.89,0,0,0,48.948,3.142Z"
                  transform="translate(-28.237)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_2703"
              data-name="Group 2703"
              transform="translate(0.001 13.119)"
            >
              <g id="Group_2702" data-name="Group 2702">
                <path
                  id="Path_2909"
                  data-name="Path 2909"
                  d="M21.035,297.2a.89.89,0,0,0-1.2.388,9.458,9.458,0,0,1-16.454.785l1.269.906a.89.89,0,1,0,1.034-1.448L1.84,295.079a.891.891,0,0,0-1.4.643L0,300.461a.89.89,0,1,0,1.772.162l.118-1.293a11.23,11.23,0,0,0,19.528-.937A.89.89,0,0,0,21.035,297.2Z"
                  transform="translate(-0.001 -294.913)"
                  fill="currentColor"
                />
              </g>
            </g>
          </g>
        </svg>
      ) : props.name === IconName.SEARCH ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30.321"
          height="30.32"
          viewBox="0 0 30.321 30.32"
        >
          <path
            id="Path_1701"
            data-name="Path 1701"
            d="M30.135,29.242,20.91,20.017a12.048,12.048,0,1,0-.893.893l9.226,9.226a.632.632,0,1,0,.893-.893ZM12,22.74A10.739,10.739,0,1,1,22.74,12,10.751,10.751,0,0,1,12,22.74Z"
          />
        </svg>
      ) : props.name === IconName.SHARE_FACEBOOK ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
        >
          <g id="facebook" opacity="0.15">
            <g id="Group_2801" data-name="Group 2801">
              <path
                id="Path_2980"
                data-name="Path 2980"
                d="M15,0A15,15,0,1,0,30,15,15.017,15.017,0,0,0,15,0Zm3.73,15.528H16.29v8.7H12.674v-8.7H10.955V12.454h1.719V10.465a3.391,3.391,0,0,1,3.649-3.649l2.68.01V9.81H17.058a.736.736,0,0,0-.767.837v1.807h2.755Z"
              />
            </g>
          </g>
        </svg>
      ) : props.name === IconName.SHARE_MESSENGER ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
        >
          <g id="Layer_2" data-name="Layer 2" opacity="0.15">
            <g id="Color">
              <g id="_38.Messenger" data-name="38.Messenger">
                <path
                  id="Path_2981"
                  data-name="Path 2981"
                  d="M61.829,64.2l-2.975,1.624a.326.326,0,0,1-.4-.063L56.72,63.926a.259.259,0,0,0-.378,0L52.76,67.719a.117.117,0,0,0,.14.182l3.034-1.634a.328.328,0,0,1,.39.061l1.721,1.808a.259.259,0,0,0,.376,0l3.548-3.754a.115.115,0,0,0-.14-.182Z"
                  transform="translate(-42.436 -51.295)"
                />
                <path
                  id="Path_2982"
                  data-name="Path 2982"
                  d="M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm0,21.748a8.432,8.432,0,0,1-2.183-.284l-2.465,1.4a.184.184,0,0,1-.274-.156l-.032-2.576a7.115,7.115,0,0,1-2.941-5.7A7.628,7.628,0,0,1,15,7.105c4.36,0,7.895,3.276,7.895,7.318A7.628,7.628,0,0,1,15,21.748Z"
                />
              </g>
            </g>
          </g>
        </svg>
      ) : props.name === IconName.SHARE_EMAIL ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
        >
          <path
            id="Path_2983"
            data-name="Path 2983"
            d="M-833.994,104.53a15,15,0,0,0-15,15,15,15,0,0,0,15,15,15,15,0,0,0,15-15A15,15,0,0,0-833.994,104.53Zm-7.332,8.224h14.664a1.545,1.545,0,0,1,.67.157l-6.251,6.25h0l-1.786,1.716L-842,112.911A1.545,1.545,0,0,1-841.326,112.754Zm-1.564,11.988V114.318a1.545,1.545,0,0,1,.157-.67l5.882,5.882-5.882,5.882A1.545,1.545,0,0,1-842.89,124.742Zm16.227,1.564h-14.664a1.546,1.546,0,0,1-.67-.157l5.882-5.882,1.716,1.716a.519.519,0,0,0,.369.153.519.519,0,0,0,.368-.153l1.786-1.716,5.882,5.882A1.545,1.545,0,0,1-826.662,126.306Zm1.564-1.564a1.546,1.546,0,0,1-.157.67l-5.882-5.882,5.882-5.882a1.546,1.546,0,0,1,.156.67Z"
            transform="translate(848.994 -104.53)"
            opacity="0.15"
          />
        </svg>
      ) : props.name === IconName.SHARE_MESSAGE ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
        >
          <g id="Layer_2" data-name="Layer 2" opacity="0.15">
            <g id="Color">
              <g id="_38.Messenger" data-name=" 38.Messenger">
                <path
                  id="Path_2990"
                  data-name="Path 2990"
                  d="M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm0,21.748a8.432,8.432,0,0,1-2.183-.284l-2.465,1.4a.183.183,0,0,1-.274-.156l-.032-2.576a7.115,7.115,0,0,1-2.941-5.7A7.628,7.628,0,0,1,15,7.105c4.36,0,7.895,3.276,7.895,7.318A7.628,7.628,0,0,1,15,21.748Z"
                />
              </g>
            </g>
          </g>
        </svg>
      ) : props.name === IconName.SHARE_LINK ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 30 30"
        >
          <g id="link" transform="translate(-0.001)" opacity="0.15">
            <g
              id="Group_2807"
              data-name="Group 2807"
              transform="translate(0.001)"
            >
              <g
                id="Group_2806"
                data-name="Group 2806"
                transform="translate(0)"
              >
                <path
                  id="Path_2985"
                  data-name="Path 2985"
                  d="M15,0A15,15,0,1,0,30,15,15,15,0,0,0,15,0Zm7.537,12.33L18.869,16a2.107,2.107,0,0,1-2.979,0l-.144-.144-.391.391.143.143a2.109,2.109,0,0,1,0,2.979l-3.668,3.669a2.107,2.107,0,0,1-2.98,0L7.464,21.65a2.109,2.109,0,0,1,0-2.979L11.133,15a2.107,2.107,0,0,1,2.98,0l.143.143.391-.391-.143-.143a2.109,2.109,0,0,1,0-2.979l3.669-3.669a2.107,2.107,0,0,1,2.98,0l1.387,1.387A2.109,2.109,0,0,1,22.537,12.33Z"
                  transform="translate(-0.001)"
                />
                <path
                  id="Path_2986"
                  data-name="Path 2986"
                  d="M89.867,160.818l-.708.708-1.1-1.1.708-.708-.143-.143a.55.55,0,0,0-.777,0l-3.661,3.661a.55.55,0,0,0,0,.777l1.384,1.385a.563.563,0,0,0,.777,0l3.661-3.661a.55.55,0,0,0,0-.777Z"
                  transform="translate(-75.62 -143.467)"
                />
                <path
                  id="Path_2987"
                  data-name="Path 2987"
                  d="M159.008,89.191a.55.55,0,0,0-.778,0l-3.661,3.661a.551.551,0,0,0,0,.777l.143.143,1.086-1.086,1.1,1.1-1.086,1.086.143.143a.563.563,0,0,0,.777,0l3.661-3.661a.55.55,0,0,0,0-.777Z"
                  transform="translate(-138.96 -80.123)"
                />
              </g>
            </g>
          </g>
        </svg>
      ) : props.name === IconName.SHARE_PDF ? (
        <svg xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 30 30">
          <path d="M15,0C6.7,0,0,6.7,0,15s6.7,15,15,15s15-6.7,15-15S23.3,0,15,0z M19.9,24.7h-9.8c-0.7,0-1.2-0.6-1.2-1.2  c0-0.7,0.6-1.2,1.2-1.2h9.8c0.7,0,1.2,0.6,1.2,1.2C21.2,24.1,20.6,24.7,19.9,24.7z M20.8,15.3l-4.9,4.9c-0.5,0.5-1.3,0.5-1.8,0  l-4.9-4.9c-0.5-0.5-0.5-1.3,0-1.8c0.5-0.5,1.3-0.5,1.8,0l2.8,2.8V5.2C13.8,4.5,14.3,4,15,4s1.2,0.6,1.2,1.2v11.1l2.8-2.8  c0.5-0.5,1.3-0.5,1.8,0C21.3,14,21.3,14.8,20.8,15.3L20.8,15.3z"/>
        </svg>
      ) : props.name === IconName.SPEECH_BUBBLE ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="72.582"
          height="25.259"
          viewBox="0 0 72.582 25.259"
        >
          <path
            id="Path_764"
            data-name="Path 764"
            d="M13,6.5H79.58a3,3,0,0,1,3,3V23a3,3,0,0,1-3,3H51.093L45.3,31.759l-5-5.759H13a3,3,0,0,1-3-3V9.5A3,3,0,0,1,13,6.5Z"
            transform="translate(-9.998 -6.5)"
            fill="#1c1b1b"
          />
        </svg>
      ) : props.name === IconName.THREE_D ? (
        <svg
          id="icon-3d-large-black"
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
        >
          <circle
            id="Ellipse_33"
            data-name="Ellipse 33"
            cx="20"
            cy="20"
            r="20"
          />
          <g
            id="Ellipse_33"
            data-name="Ellipse 33"
            fill="#fff"
            stroke="#000"
            strokeWidth="2"
          >
            <circle stroke="none" cx="20" cy="20" r="20" />
            <circle fill="none" cx="20" cy="20" r="19" />
          </g>
          <path
            id="Path_4114"
            data-name="Path 4114"
            d="M8.37-7.83c0-1.9-1.29-3.045-3.525-3.045-2.175,0-3.375.825-3.96,2.5a.47.47,0,0,0,.33.66l.81.285c.375.12.525.045.66-.315.36-1.005.825-1.38,2.13-1.38,1.125,0,1.68.48,1.68,1.455A1.4,1.4,0,0,1,4.92-6.255H3.63c-.375,0-.51.135-.51.51v.675c0,.405.135.51.51.51H5.19c1.035,0,1.56.495,1.56,1.5S6.12-1.53,4.86-1.53c-1.38,0-1.905-.42-2.265-1.395-.165-.36-.3-.435-.66-.315l-.81.285A.47.47,0,0,0,.8-2.3C1.38-.615,2.745.225,4.86.225c2.535,0,3.855-1.26,3.855-3.255A2.549,2.549,0,0,0,7.2-5.565,2.4,2.4,0,0,0,8.37-7.83Zm3.135-2.82c-.375,0-.525.135-.525.51V-.51c0,.375.15.51.525.51h3.36c2.76,0,4.35-1.5,4.35-3.96V-6.69c0-2.46-1.59-3.96-4.35-3.96Zm5.835,6.7c0,1.425-.885,2.19-2.46,2.19H12.87v-7.14h2.01c1.575,0,2.46.765,2.46,2.19Z"
            transform="translate(10 26)"
            fill="#1c1b1b"
          />
        </svg>
      ) : props.name === IconName.TIMES ? (
        <svg
          id="cancel"
          xmlns="http://www.w3.org/2000/svg"
          width="36.365"
          height="36.365"
          viewBox="0 0 36.365 36.365"
        >
          <g id="Group_2456" data-name="Group 2456" transform="translate(0 0)">
            <path
              id="Path_2781"
              data-name="Path 2781"
              d="M20.314,18.192,35.9,2.6A1.514,1.514,0,0,0,33.8.426l-.037.037L18.173,16.051,2.585.463A1.514,1.514,0,0,0,.443,2.6L16.031,18.192.443,33.781a1.514,1.514,0,0,0,2.141,2.141L18.173,20.334,33.761,35.922A1.514,1.514,0,0,0,35.9,33.781Z"
              transform="translate(0 0)"
              fill="#b62427"
            />
          </g>
        </svg>
      ) : props.name === IconName.TILES ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28.309"
          height="28.309"
          viewBox="0 0 28.309 28.309"
        >
          <path
            id="tiles"
            d="M37.462,10H10.348a.348.348,0,0,0-.348.348v3.163a.348.348,0,0,0,.348.348h.061v4.986a1.978,1.978,0,0,0,.011.207.328.328,0,0,0-.011.056V24.44a1.979,1.979,0,0,0,.02.264.338.338,0,0,0-.02.1v5.333a1.979,1.979,0,0,0,.02.264.338.338,0,0,0-.02.1v5.333a1.982,1.982,0,0,0,1.98,1.98H15.7a1.979,1.979,0,0,0,1.632-.862,1.979,1.979,0,0,0,1.632.862h3.309a1.979,1.979,0,0,0,1.632-.862,1.979,1.979,0,0,0,1.632.862h3.309a1.979,1.979,0,0,0,1.632-.862,1.979,1.979,0,0,0,1.632.862h3.309a1.982,1.982,0,0,0,1.98-1.98V30.5a.338.338,0,0,0-.02-.1,1.979,1.979,0,0,0,.02-.264V24.8a.338.338,0,0,0-.02-.1,1.979,1.979,0,0,0,.02-.264V19.107a.328.328,0,0,0-.011-.056,1.978,1.978,0,0,0,.011-.207V13.858h.061a.348.348,0,0,0,.348-.348V10.348A.348.348,0,0,0,37.462,10ZM10.7,10.7H37.114v2.468H10.7Zm26.01,19.44a1.286,1.286,0,0,1-1.285,1.285H32.111a1.286,1.286,0,0,1-1.285-1.285V25.944a1.97,1.97,0,0,0,1.285.476h3.309a1.97,1.97,0,0,0,1.285-.476ZM12.389,20.726H15.7a2.055,2.055,0,0,0,1.285-.428V24.44A1.286,1.286,0,0,1,15.7,25.725H12.389A1.286,1.286,0,0,1,11.1,24.44V20.3A2.055,2.055,0,0,0,12.389,20.726Zm11.168-6.867v4.986a1.211,1.211,0,0,1-1.285,1.186H18.963a1.211,1.211,0,0,1-1.285-1.186V13.858ZM30.131,24.44a1.286,1.286,0,0,1-1.285,1.285H25.537a1.286,1.286,0,0,1-1.285-1.285V20.3a2.055,2.055,0,0,0,1.285.428h3.309a2.055,2.055,0,0,0,1.285-.428ZM17.678,20.3a2.055,2.055,0,0,0,1.285.428h3.309a2.055,2.055,0,0,0,1.285-.428V24.44a1.286,1.286,0,0,1-1.285,1.285H18.963a1.286,1.286,0,0,1-1.285-1.285ZM11.1,25.944a1.97,1.97,0,0,0,1.285.476H15.7a1.97,1.97,0,0,0,1.285-.476v4.191A1.286,1.286,0,0,1,15.7,31.42H12.389A1.286,1.286,0,0,1,11.1,30.135Zm6.574,0a1.97,1.97,0,0,0,1.285.476h3.309a1.97,1.97,0,0,0,1.285-.476v4.191a1.286,1.286,0,0,1-1.285,1.285H18.963a1.286,1.286,0,0,1-1.285-1.285Zm6.574,0a1.97,1.97,0,0,0,1.285.476h3.309a1.97,1.97,0,0,0,1.285-.476v4.191a1.286,1.286,0,0,1-1.285,1.285H25.537a1.286,1.286,0,0,1-1.285-1.285Zm12.453-1.5a1.286,1.286,0,0,1-1.285,1.285H32.111a1.286,1.286,0,0,1-1.285-1.285V20.3a2.055,2.055,0,0,0,1.285.428h3.309a2.055,2.055,0,0,0,1.285-.428Zm-6.574-5.6a1.211,1.211,0,0,1-1.285,1.186H25.537a1.211,1.211,0,0,1-1.285-1.186V13.858h5.879ZM16.983,13.858v4.986A1.2,1.2,0,0,1,15.7,20.03H12.389A1.2,1.2,0,0,1,11.1,18.844V13.858ZM15.7,37.114H12.389A1.286,1.286,0,0,1,11.1,35.829V31.638a1.97,1.97,0,0,0,1.285.476H15.7a1.97,1.97,0,0,0,1.285-.476v4.191A1.286,1.286,0,0,1,15.7,37.114Zm6.574,0H18.963a1.286,1.286,0,0,1-1.285-1.285V31.638a1.97,1.97,0,0,0,1.285.476h3.309a1.97,1.97,0,0,0,1.285-.476v4.191A1.286,1.286,0,0,1,22.272,37.114Zm6.574,0H25.537a1.286,1.286,0,0,1-1.285-1.285V31.638a1.97,1.97,0,0,0,1.285.476h3.309a1.97,1.97,0,0,0,1.285-.476v4.191A1.286,1.286,0,0,1,28.847,37.114Zm6.574,0H32.111a1.286,1.286,0,0,1-1.285-1.285V31.638a1.97,1.97,0,0,0,1.285.476h3.309a1.97,1.97,0,0,0,1.285-.476v4.191A1.286,1.286,0,0,1,35.421,37.114Zm1.285-18.27a1.2,1.2,0,0,1-1.285,1.186H32.111a1.2,1.2,0,0,1-1.285-1.186V13.858h5.879Z"
            transform="translate(-9.75 -9.75)"
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="0.5"
          />
        </svg>
      ) : props.name === IconName.TOUCH ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21.307"
          height="32.061"
          viewBox="0 0 21.307 32.061"
        >
          <g id="touch" transform="translate(-85.867)">
            <g
              id="Group_579"
              data-name="Group 579"
              transform="translate(94.087)"
            >
              <g id="Group_578" data-name="Group 578">
                <path
                  id="Path_843"
                  data-name="Path 843"
                  d="M217.759,0a.626.626,0,0,0-.626.626V4.488a.626.626,0,1,0,1.252,0V.626A.626.626,0,0,0,217.759,0Z"
                  transform="translate(-217.133)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_581"
              data-name="Group 581"
              transform="translate(98.443 8.22)"
            >
              <g id="Group_580" data-name="Group 580">
                <path
                  id="Path_844"
                  data-name="Path 844"
                  d="M291.193,131.266h-3.861a.626.626,0,1,0,0,1.252h3.861a.626.626,0,1,0,0-1.252Z"
                  transform="translate(-286.705 -131.266)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_583"
              data-name="Group 583"
              transform="translate(85.867 8.218)"
            >
              <g id="Group_582" data-name="Group 582">
                <path
                  id="Path_845"
                  data-name="Path 845"
                  d="M90.355,131.239H86.493a.626.626,0,1,0,0,1.252h3.861a.626.626,0,0,0,0-1.252Z"
                  transform="translate(-85.867 -131.239)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_585"
              data-name="Group 585"
              transform="translate(88.723 2.855)"
            >
              <g id="Group_584" data-name="Group 584">
                <path
                  id="Path_846"
                  data-name="Path 846"
                  d="M134.367,47.6l-1.823-1.823a.626.626,0,1,0-.886.886l1.823,1.823a.626.626,0,1,0,.886-.886Z"
                  transform="translate(-131.475 -45.589)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_587"
              data-name="Group 587"
              transform="translate(97.627 2.856)"
            >
              <g id="Group_586" data-name="Group 586">
                <path
                  id="Path_847"
                  data-name="Path 847"
                  d="M276.558,45.792a.626.626,0,0,0-.886,0l-1.823,1.823a.626.626,0,0,0,.886.886l1.823-1.823A.626.626,0,0,0,276.558,45.792Z"
                  transform="translate(-273.666 -45.608)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_589"
              data-name="Group 589"
              transform="translate(92.396 6.528)"
            >
              <g id="Group_588" data-name="Group 588">
                <path
                  id="Path_848"
                  data-name="Path 848"
                  d="M202.594,111.982a2.3,2.3,0,0,0-1.161.313,2.315,2.315,0,0,0-3.912-.923,2.311,2.311,0,0,0-2.755-.475v-4.329a2.317,2.317,0,1,0-4.634,0v3.3a.626.626,0,1,0,1.252,0v-3.3a1.065,1.065,0,1,1,2.129,0v10.483a.626.626,0,1,0,1.252,0v-4.1a1.065,1.065,0,0,1,2.129,0v4.1a.626.626,0,0,0,1.252,0v-4.1a1.065,1.065,0,1,1,2.129,0v4.1a.626.626,0,1,0,1.252,0V114.3a1.065,1.065,0,1,1,2.129,0v6.548a7.751,7.751,0,0,1-.125,1.388.626.626,0,0,0,.5.728.633.633,0,0,0,.113.01.626.626,0,0,0,.615-.514,9.016,9.016,0,0,0,.145-1.613V114.3A2.319,2.319,0,0,0,202.594,111.982Z"
                  transform="translate(-190.133 -104.252)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_591"
              data-name="Group 591"
              transform="translate(87.068 15.655)"
            >
              <g id="Group_590" data-name="Group 590">
                <path
                  id="Path_849"
                  data-name="Path 849"
                  d="M122.342,263.12a.626.626,0,0,0-.885-.031,7.685,7.685,0,0,1-12.161-2.278l-2.884-5.972a1.148,1.148,0,0,1,2.015-1.1l2.04,3.347a.626.626,0,0,0,1.161-.326v-6.137a.626.626,0,1,0-1.252,0v3.906l-.879-1.442a2.4,2.4,0,0,0-4.212,2.294l2.884,5.972a8.937,8.937,0,0,0,14.143,2.649A.626.626,0,0,0,122.342,263.12Z"
                  transform="translate(-105.047 -250)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_593"
              data-name="Group 593"
              transform="translate(104.914 26.467)"
            >
              <g id="Group_592" data-name="Group 592">
                <path
                  id="Path_850"
                  data-name="Path 850"
                  d="M391.111,422.853a.626.626,0,1,0,.183.443A.631.631,0,0,0,391.111,422.853Z"
                  transform="translate(-390.042 -422.67)"
                  fill="currentColor"
                />
              </g>
            </g>
            <g
              id="Group_595"
              data-name="Group 595"
              transform="translate(92.396 13.651)"
            >
              <g id="Group_594" data-name="Group 594">
                <path
                  id="Path_851"
                  data-name="Path 851"
                  d="M191.2,218.183a.626.626,0,1,0,.183.443A.631.631,0,0,0,191.2,218.183Z"
                  transform="translate(-190.132 -218)"
                  fill="currentColor"
                />
              </g>
            </g>
          </g>
        </svg>
      ) : props.name === IconName.UNDO ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20.713"
          height="24.049"
          viewBox="0 0 20.713 24.049"
        >
          <g id="refresh" transform="translate(-5.3 -1)">
            <g
              id="Group_668"
              data-name="Group 668"
              transform="translate(5.3 4.336)"
            >
              <g
                id="Group_667"
                data-name="Group 667"
                transform="translate(0 0)"
              >
                <g id="Group_666" data-name="Group 666">
                  <path
                    id="Path_825"
                    data-name="Path 825"
                    d="M15.656,30.313A10.379,10.379,0,0,1,5.3,19.956a.776.776,0,1,1,1.552,0,8.8,8.8,0,1,0,8.8-8.8.776.776,0,1,1,0-1.552,10.356,10.356,0,0,1,0,20.713Z"
                    transform="translate(-5.3 -9.6)"
                    fill="currentColor"
                  />
                </g>
              </g>
            </g>
            <g
              id="Group_671"
              data-name="Group 671"
              transform="translate(13.019 1)"
            >
              <g id="Group_670" data-name="Group 670">
                <g id="Group_669" data-name="Group 669">
                  <path
                    id="Path_826"
                    data-name="Path 826"
                    d="M29.389,9.378a.766.766,0,0,1-.543-.233L25.433,5.732a.75.75,0,0,1,0-1.086l3.413-3.413a.75.75,0,0,1,1.086,0,.75.75,0,0,1,0,1.086l-2.87,2.87,2.87,2.87a.75.75,0,0,1,0,1.086.651.651,0,0,1-.543.233Z"
                    transform="translate(-25.2 -1)"
                    fill="currentColor"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      ) : props.name === IconName.LAND_SITUATION_NSW_DESKTOP_VACANT ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="88.512" height="82.365" viewBox="0 0 88.512 82.365">
          <g id="Group_727" data-name="Group 727" transform="translate(-69.391 -990.873)">
            <path id="Path_952" data-name="Path 952" d="M95.926,1033.287s-1.594-16.579,8.928-23.276,19.768-4.462,19.768-4.462,1.912,14.347-6.7,22S95.926,1033.287,95.926,1033.287Z" transform="translate(23.352 12.221)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <line id="Line_43" data-name="Line 43" y1="65.972" transform="translate(112.584 1006.266)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <line id="Line_44" data-name="Line 44" x1="21.091" y2="22.319" transform="translate(112.584 1030.842)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <path id="Path_953" data-name="Path 953" d="M107.344,1028.783s-2.221-13.977-10.234-19.926c-6.238-4.633-21.005-3.649-21.005-3.649s-.431,13.692,8.817,20.626C92.579,1031.575,107.344,1028.783,107.344,1028.783Z" transform="translate(5.24 12.156)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <line id="Line_45" data-name="Line 45" x2="13.127" y2="10.08" transform="translate(99.457 1030.859)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <g id="Group_709" data-name="Group 709" transform="translate(105.69 991.873)">
              <path id="Path_954" data-name="Path 954" d="M95.693,1018.832a15,15,0,0,0,6.631-12.652,21.894,21.894,0,0,0-5.571-14.307s-6.752,7.406-7.78,13.293C87.511,1013.542,95.693,1018.832,95.693,1018.832Z" transform="translate(-88.799 -991.873)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            </g>
            <line id="Line_46" data-name="Line 46" x2="86.512" transform="translate(70.391 1072.238)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          </g>
        </svg>
      ) : props.name === IconName.LAND_SITUATION_NSW_DESKTOP_LOOKING ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="88.512" height="82.365" viewBox="0 0 88.512 82.365">
          <g id="Group_727" data-name="Group 727" transform="translate(-69.391 -990.873)">
            <path id="Path_952" data-name="Path 952" d="M95.926,1033.287s-1.594-16.579,8.928-23.276,19.768-4.462,19.768-4.462,1.912,14.347-6.7,22S95.926,1033.287,95.926,1033.287Z" transform="translate(23.352 12.221)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <line id="Line_43" data-name="Line 43" y1="65.972" transform="translate(112.584 1006.266)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <line id="Line_44" data-name="Line 44" x1="21.091" y2="22.319" transform="translate(112.584 1030.842)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <path id="Path_953" data-name="Path 953" d="M107.344,1028.783s-2.221-13.977-10.234-19.926c-6.238-4.633-21.005-3.649-21.005-3.649s-.431,13.692,8.817,20.626C92.579,1031.575,107.344,1028.783,107.344,1028.783Z" transform="translate(5.24 12.156)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <line id="Line_45" data-name="Line 45" x2="13.127" y2="10.08" transform="translate(99.457 1030.859)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            <g id="Group_709" data-name="Group 709" transform="translate(105.69 991.873)">
              <path id="Path_954" data-name="Path 954" d="M95.693,1018.832a15,15,0,0,0,6.631-12.652,21.894,21.894,0,0,0-5.571-14.307s-6.752,7.406-7.78,13.293C87.511,1013.542,95.693,1018.832,95.693,1018.832Z" transform="translate(-88.799 -991.873)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            </g>
            <line id="Line_46" data-name="Line 46" x2="86.512" transform="translate(70.391 1072.238)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          </g>
        </svg>
      ) : props.name === IconName.LAND_SITUATION_NSW_DESKTOP_KDR ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="128.62" height="101.603" viewBox="0 0 128.62 101.603">
          <defs>
            <clipPath id="clip-path">
              <path id="Path_963" data-name="Path 963" d="M937.5,1092.389h-95.76l32.35-84.328H937.5Z" transform="translate(-826.98 -986.711)" fill="none" stroke="currentColor" strokeWidth="2"/>
            </clipPath>
            <clipPath id="clip-path-2">
              <path id="Path_966" data-name="Path 966" d="M795.993,1056.756h33.759l20.558-53.564H795.993Z" transform="translate(-745.643 -950.723)" fill="none" stroke="currentColor" strokeWidth="2"/>
            </clipPath>
          </defs>
          <g id="Group_4477" data-name="Group 4477" transform="translate(-1507.784 -3487.576)">
            <g id="Group_716" data-name="Group 716" transform="translate(1525.883 3474.875)">
              <g id="Group_715" data-name="Group 715" clipPath="url(#clip-path)">
                <g id="Group_714" data-name="Group 714" transform="translate(9.004 24.158)">
                  <line id="Line_55" data-name="Line 55" x1="58.019" y2="21.181" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                  <line id="Line_56" data-name="Line 56" y2="76.888" transform="translate(53.809 1.537)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                  <path id="Path_960" data-name="Path 960" d="M833.116,1006.934v58.616h87.791" transform="translate(-828.566 -986.421)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                  <line id="Line_57" data-name="Line 57" x1="44.822" y1="16.193" transform="translate(53.809 19.709)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                  <line id="Line_58" data-name="Line 58" y1="45.069" transform="translate(92.341 34.029)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                  <rect id="Rectangle_190" data-name="Rectangle 190" width="26.23" height="15.189" transform="translate(42.022 42.995) rotate(-180)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                  <path id="Path_961" data-name="Path 961" d="M868,1047.084v-25.61H837.357v25.886" transform="translate(-823.439 -968.843)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                  <path id="Path_962" data-name="Path 962" d="M873.456,1047.084v-25.61H861.411v25.7" transform="translate(-794.359 -968.843)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                </g>
              </g>
            </g>
            <g id="Group_722" data-name="Group 722" transform="translate(1457.434 3474.875)" clipPath="url(#clip-path-2)">
              <g id="Group_721" data-name="Group 721" transform="translate(52.681 55.785)">
                <path id="Path_964" data-name="Path 964" d="M823.049,1020.991v27.8h57.738v-27.26" transform="translate(-815.965 -1001.053)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                <g id="Group_717" data-name="Group 717">
                  <path id="Path_965" data-name="Path 965" d="M855.441,1011.965l-35.6,17.485v5.947l35.6-17.485,35.6,17.485v-5.947Z" transform="translate(-819.842 -1011.965)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
                </g>
                <g id="Group_720" data-name="Group 720" transform="translate(47.789 26.539)">
                  <g id="Group_718" data-name="Group 718" transform="translate(0 10.886)">
                    <ellipse id="Ellipse_31" data-name="Ellipse 31" cx="1.105" cy="0.755" rx="1.105" ry="0.755" fill="currentColor" stroke="currentColor" strokeWidth="2"/>
                  </g>
                  <g id="Group_719" data-name="Group 719" transform="translate(1.713)">
                    <ellipse id="Ellipse_32" data-name="Ellipse 32" cx="1.105" cy="0.755" rx="1.105" ry="0.755" fill="currentColor" stroke="currentColor" strokeWidth="2"/>
                  </g>
                </g>
              </g>
            </g>
            <line id="Line_59" data-name="Line 59" y1="99.013" x2="38.534" transform="translate(1538.084 3488.871)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          </g>
        </svg>
      ) : props.name === IconName.LAND_SITUATION_NSW_DESKTOP_HL ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="140.827" height="77.204" viewBox="0 0 140.827 77.204">
          <g id="Group_728" data-name="Group 728" transform="translate(-181.352 -992.174)">
            <g id="Group_711" data-name="Group 711" transform="translate(189.438 993.456)">
              <line id="Line_47" data-name="Line 47" x2="54.478" y2="19.889" transform="translate(38.133)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
              <line id="Line_48" data-name="Line 48" y2="72.856" transform="translate(42.086 1.443)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
              <line id="Line_49" data-name="Line 49" y2="9.392" transform="translate(88.338 64.907)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
              <line id="Line_50" data-name="Line 50" y2="17.408" transform="translate(88.338 19.26)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
              <line id="Line_51" data-name="Line 51" y1="15.205" x2="42.086" transform="translate(0 18.506)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
              <line id="Line_52" data-name="Line 52" y1="42.347" transform="translate(5.906 31.952)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
              <rect id="Rectangle_189" data-name="Rectangle 189" width="24.629" height="14.262" transform="translate(53.154 26.109)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
              <path id="Path_955" data-name="Path 955" d="M213.417,1044.873v-24.881h28.776v24.881" transform="translate(-162.651 -970.574)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
              <path id="Path_956" data-name="Path 956" d="M196.006,1044.873v-24.881h11.31v24.881" transform="translate(-177.665 -970.574)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            </g>
            <g id="Group_712" data-name="Group 712" transform="translate(273.721 1024.023)">
              <path id="Path_957" data-name="Path 957" d="M253.438,1052.989v-7.881a44.718,44.718,0,0,1-7.561-1.153c-2.305-.769-3.395-1.473-3.715-2.819s.32-3.395,1.089-5,1.473-3.14,1.345-4.295-.384-3.332.512-4.676,2.287-2.114,2.65-3.2-.426-1.475,0-3.4,2.283-4.8,4.462-6.984,3.652-3.715,3.652-3.715" transform="translate(-222.221 -1009.87)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
              <path id="Path_958" data-name="Path 958" d="M251.921,1052.989v-7.881a44.678,44.678,0,0,0,7.559-1.153c2.307-.769,3.4-1.473,3.717-2.819s-.32-3.395-1.089-5-1.473-3.14-1.346-4.295.385-3.332-.512-4.676-2.285-2.114-2.648-3.2.426-1.475,0-3.4-2.285-4.8-4.464-6.984-3.652-3.715-3.652-3.715" transform="translate(-215.834 -1009.87)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
              <line id="Line_53" data-name="Line 53" y2="8.329" transform="translate(18.306 34.79)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
              <path id="Path_959" data-name="Path 959" d="M254.133,1017.236a5.315,5.315,0,0,0-9.382-1.669,5.315,5.315,0,0,0-8.745,4.062l0,.056a9.243,9.243,0,0,0,.724,16.943c.158,0,.313-.011.467-.024a5.314,5.314,0,0,0,8.2,3.451l.093,9.887" transform="translate(-231.415 -1006.822)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
            </g>
            <line id="Line_54" data-name="Line 54" x1="135.084" transform="translate(182.352 1068.378)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"/>
          </g>
        </svg>
      ) : props.name === IconName.CLOSE ? (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g>
            <rect x="12.2251" y="0.786774" width="1.25526" height="16.3183" transform="rotate(45 12.2251 0.786774)"/>
            <rect x="0.68631" y="1.67436" width="1.25526" height="16.3183" transform="rotate(-45 0.68631 1.67436)"/>
          </g>
        </svg>
      ) : props.name === IconName.ENVELOPE ? (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
          <path fill="currentColor" d="M112 128C85.5 128 64 149.5 64 176C64 191.1 71.1 205.3 83.2 214.4L291.2 370.4C308.3 383.2 331.7 383.2 348.8 370.4L556.8 214.4C568.9 205.3 576 191.1 576 176C576 149.5 554.5 128 528 128L112 128zM64 260L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 260L377.6 408.8C343.5 434.4 296.5 434.4 262.4 408.8L64 260z"/>
        </svg>
      ) : props.name === IconName.LOT_WIDTH ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path data-name="Path 4142" d="M16.5,0H1.5A1.5,1.5,0,0,0,0,1.5v15A1.5,1.5,0,0,0,1.5,18h15A1.5,1.5,0,0,0,18,16.5V1.5A1.5,1.5,0,0,0,16.5,0Zm-.97,9.53-2.651,2.652-1.06-1.061L13.189,9.75H4.811l1.372,1.371L5.121,12.182,2.47,9.53a.75.75,0,0,1,0-1.06L5.121,5.818l1.06,1.06L4.811,8.25H13.19L11.818,6.879l1.061-1.061L15.53,8.47A.75.75,0,0,1,15.53,9.53Z" fill="currentColor"/>
        </svg>
      ) : null}
    </div>
  );
};

export default Icon;
